var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 828 552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_13248424_5150936",
    "data-name": "13248424_5150936",
    d: "M20,0H828a0,0,0,0,1,0,0V552a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z",
    transform: "translate(140 157)",
    fill: "#d5d5d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0-666.665H828v552H0Z",
    transform: "translate(0 666.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-140 -157)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(140 823.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M0-114.665H828v-552H0Z",
    fill: "#ebfaff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 -666.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(344.023 382.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M-24.406-22.567-34.959-131.206h-74.1L-119.531-23.434c-.283,2.906-3.226,5.146-6.761,5.146H-141.9v5.826H-2.124v-5.826H-18.783c-2.94,0-5.388-1.864-5.623-4.279",
    transform: "translate(141.897 131.206)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(372.576 382.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M-17.345-10.862l-5.08-52.289H-96.531l-4.316,44.435Z",
    transform: "translate(100.846 63.151)",
    fill: "#efe0d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(217.796 145.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M-78.794-56.769H-445.2a12.91,12.91,0,0,1-12.91-12.91V-317.145a12.909,12.909,0,0,1,12.91-12.91H-78.794a12.91,12.91,0,0,1,12.91,12.91V-69.679a12.911,12.911,0,0,1-12.91,12.91",
    transform: "translate(458.11 330.055)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M638.467-234.016H288.643V-465.465H638.467Z",
    transform: "translate(-49.646 632.059)",
    fill: "#0b132b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M638.467-465.137H288.643v-.828H638.467Z",
    transform: "translate(-49.646 632.145)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M543.5-67.55H433.408v-.828H543.5Z",
    transform: "translate(-74.545 563.761)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(399.655 153.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M-.6-.172a2.042,2.042,0,0,0-2.04,2.04A2.042,2.042,0,0,0-.6,3.907H22.176a2.04,2.04,0,1,0,0-4.079ZM22.176,4.735H-.6A2.871,2.871,0,0,1-3.464,1.868,2.872,2.872,0,0,1-.6-1H22.176a2.868,2.868,0,1,1,0,5.735",
    transform: "translate(3.464 1)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M532.065-160.346H450.948v-.828h81.116Z",
    transform: "translate(-77.562 579.722)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(271.873 8.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M-30.911-.2q-2.193-.1-4.4-.128l.01-.828q2.221.03,4.426.129Zm-13.2.017-.039-.827q2.2-.1,4.426-.14l.012.828q-2.207.035-4.4.139m21.98.648q-2.183-.233-4.383-.4l.062-.826q2.214.167,4.409.4ZM-52.889.5-52.98-.32c1.467-.16,2.95-.3,4.407-.413l.065.826c-1.451.113-2.924.251-4.382.41m39.476,1.169Q-15.58,1.3-17.766,1l.115-.82c1.458.2,2.931.428,4.375.675Zm-48.193.059-.14-.816C-60.3.664-58.827.433-57.372.229l.115.82c-1.446.2-2.909.432-4.35.681M-4.788,3.42q-2.14-.5-4.3-.942l.163-.811q2.176.44,4.327.946ZM-70.229,3.5l-.192-.806c1.419-.338,2.873-.66,4.323-.957l.166.81c-1.441.3-2.887.616-4.3.953M3.714,5.7q-2.1-.636-4.233-1.209L-.3,3.7q2.143.576,4.256,1.216Zm-82.439.1-.241-.792c1.4-.427,2.831-.84,4.254-1.227l.217.8c-1.415.384-2.838.794-4.231,1.219M12.082,8.525Q10.015,7.757,7.92,7.049l.265-.785q2.108.712,4.186,1.485Zm-99.14.11-.291-.775c1.377-.517,2.78-1.018,4.169-1.49l.267.784c-1.381.469-2.777.968-4.144,1.482m107.309,3.23q-2.015-.9-4.058-1.734l.312-.766q2.057.841,4.081,1.743Zm-115.439.114-.338-.756c1.351-.606,2.717-1.192,4.056-1.742l.316.766c-1.333.546-2.689,1.129-4.034,1.732m123.38,3.729q-1.952-1.022-3.939-1.984l.36-.744q2,.965,3.963,1.994Zm-131.275.11-.386-.733c1.306-.686,2.632-1.356,3.943-1.993l.362.744c-1.3.634-2.622,1.3-3.919,1.982M35.872,20.039q-1.885-1.141-3.807-2.225l.407-.721q1.933,1.09,3.829,2.237Zm-146.6.106-.429-.708c1.266-.769,2.549-1.521,3.813-2.236l.407.721c-1.256.71-2.531,1.457-3.791,2.222M43.266,24.836q-1.808-1.255-3.659-2.455l.45-.694q1.86,1.207,3.681,2.47Zm-161.362.1-.471-.679c1.21-.843,2.444-1.674,3.669-2.47l.45.694c-1.217.79-2.443,1.616-3.648,2.454M50.345,30.081q-1.729-1.365-3.5-2.677l.493-.666q1.78,1.32,3.518,2.693Zm-175.5.1-.513-.649q1.734-1.373,3.51-2.693l.493.665q-1.765,1.312-3.49,2.677M57.082,35.752q-1.639-1.469-3.325-2.887l.533-.634q1.694,1.426,3.344,2.9Zm-188.96.1-.554-.616c1.105-.991,2.229-1.97,3.34-2.906l.533.634c-1.1.931-2.221,1.9-3.319,2.888m195.332,5.97q-1.548-1.567-3.14-3.086l.571-.6q1.6,1.527,3.157,3.1Zm-201.7.109-.591-.581c1.039-1.055,2.1-2.1,3.155-3.108l.571.6c-1.048,1-2.1,2.039-3.135,3.089M69.436,48.281q-1.447-1.659-2.942-3.273l.607-.563q1.5,1.623,2.958,3.291Zm-213.657.118-.625-.544q1.454-1.671,2.957-3.3l.607.562q-1.492,1.616-2.939,3.279M75.006,55.09q-1.341-1.745-2.732-3.448l.64-.524q1.4,1.712,2.748,3.468Zm-224.794.132-.657-.5q1.348-1.759,2.747-3.475l.643.524q-1.393,1.7-2.732,3.454m229.932,7q-1.23-1.825-2.515-3.608l.673-.485q1.29,1.8,2.527,3.63Zm-235.07.155-.688-.461c.834-1.242,1.685-2.467,2.529-3.641l.672.484c-.839,1.167-1.685,2.384-2.514,3.619m239.75,7.283q-1.114-1.9-2.283-3.755l.7-.442q1.176,1.87,2.3,3.777Zm-244.436.183-.714-.418q1.121-1.916,2.3-3.792l.7.44q-1.171,1.865-2.285,3.77M89.032,77.374q-.994-1.961-2.045-3.887l.726-.4q1.058,1.938,2.057,3.91Zm-252.856.22-.74-.373q1-1.982,2.059-3.93l.726.4q-1.052,1.936-2.046,3.907M92.75,85.326q-.869-2.019-1.8-4.005l.75-.35q.936,2,1.808,4.027Zm-260.3.266-.761-.325q.874-2.044,1.809-4.053l.75.349q-.927,2-1.8,4.028M95.97,93.5q-.745-2.073-1.55-4.12l.771-.3q.81,2.057,1.558,4.144Zm-266.73.31-.781-.277c.492-1.387,1.016-2.786,1.552-4.161l.773.3c-.535,1.366-1.054,2.757-1.544,4.136M98.673,101.88c-.405-1.407-.839-2.823-1.286-4.21l.787-.254c.45,1.394.887,2.819,1.295,4.234Zm-272.123.33-.8-.227c.405-1.418.837-2.843,1.284-4.237l.789.252c-.445,1.388-.874,2.8-1.277,4.213m274.3,8.2c-.315-1.421-.659-2.86-1.021-4.281l.8-.2c.365,1.429.711,2.877,1.028,4.307Zm-276.452.336-.808-.178c.318-1.45.66-2.9,1.017-4.309l.8.2c-.354,1.4-.694,2.843-1.011,4.284m278.089,8.313q-.344-2.179-.752-4.337l.814-.155q.411,2.171.755,4.362Zm-279.705.34-.818-.126c.224-1.446.474-2.915.745-4.364l.814.151c-.269,1.443-.519,2.9-.741,4.339m280.8,8.394q-.209-2.2-.48-4.376l.821-.1q.273,2.191.482,4.4Zm-281.875.343-.824-.076q.2-2.211.471-4.4l.821.1q-.265,2.179-.469,4.377m282.425,8.442q-.071-2.207-.208-4.4l.826-.052q.137,2.2.21,4.423Zm-282.956.343-.828-.024q.066-2.221.2-4.423l.826.05q-.131,2.191-.2,4.4m283.792,8.713-.828-.025q.068-2.193.068-4.4v-.229h.828v.229q0,2.222-.068,4.427m-284.615.117q-.07-2.206-.071-4.427h.828q0,2.209.071,4.4Zm284.072,8.719-.824-.077q.2-2.184.338-4.387l.826.051q-.136,2.216-.34,4.414m-283.522.118q-.205-2.2-.342-4.414l.826-.052q.137,2.2.341,4.388Zm282.437,8.669-.818-.127q.336-2.169.608-4.36l.821.1q-.272,2.2-.612,4.385M-178,163.372q-.341-2.181-.617-4.384l.821-.1q.275,2.189.613,4.359ZM101.7,171.958l-.808-.178c.316-1.433.611-2.884.88-4.312l.813.152c-.268,1.437-.566,2.9-.884,4.338m-278.066.115q-.477-2.156-.889-4.337l.814-.153q.411,2.168.883,4.311Zm275.893,8.469-.795-.227q.6-2.111,1.147-4.25l.8.2q-.545,2.149-1.154,4.274m-273.714.113c-.406-1.406-.795-2.845-1.158-4.274l.8-.2c.361,1.419.749,2.848,1.151,4.247Zm271,8.332-.781-.278c.49-1.368.966-2.774,1.416-4.182l.789.253c-.455,1.415-.933,2.832-1.425,4.207m-268.287.1c-.5-1.392-.975-2.8-1.423-4.193l.788-.254c.445,1.382.921,2.784,1.415,4.169Zm265.048,8.17-.762-.326c.583-1.36,1.146-2.734,1.675-4.084l.772.3c-.532,1.358-1.1,2.74-1.685,4.108m-261.818.059q-.868-2.024-1.677-4.082l.769-.3q.8,2.045,1.669,4.058ZM89.829,205.3l-.74-.373q.994-1.967,1.926-3.969l.751.351q-.939,2.012-1.938,3.991m-254.333.018q-.994-1.969-1.93-3.972l.751-.351q.929,1.992,1.919,3.95Zm4.228,7.758q-1.116-1.9-2.174-3.846l.726-.4q1.052,1.931,2.162,3.825Zm245.86.013-.713-.418q1.114-1.9,2.17-3.839l.726.4c-.708,1.3-1.443,2.6-2.184,3.861m-241.157,7.472q-1.232-1.833-2.41-3.706l.7-.441q1.171,1.861,2.4,3.685Zm236.442.034-.687-.463c.81-1.2,1.62-2.448,2.4-3.694l.7.442c-.787,1.254-1.6,2.5-2.417,3.715m-231.283,7.148q-1.345-1.754-2.636-3.55l.673-.484q1.283,1.785,2.621,3.531Zm226.108.047-.657-.5q1.34-1.745,2.628-3.536l.672.484q-1.295,1.8-2.643,3.557m-220.511,6.805q-1.451-1.668-2.852-3.383l.64-.524q1.394,1.706,2.837,3.364Zm214.9.053-.625-.543q1.446-1.661,2.841-3.366l.64.523q-1.4,1.716-2.856,3.386M-138.8,241.088q-1.552-1.578-3.057-3.2l.608-.563q1.5,1.616,3.039,3.184Zm202.874.052-.588-.581q1.545-1.568,3.04-3.183l.608.563q-1.505,1.625-3.06,3.2M-132.4,247.2q-1.648-1.48-3.25-3.008l.572-.6q1.591,1.52,3.23,2.991Zm190.064.047-.552-.616c1.089-.975,2.175-1.981,3.231-2.989l.572.6c-1.062,1.013-2.156,2.025-3.251,3.005m-183.292,5.661q-1.737-1.374-3.431-2.8l.532-.634q1.686,1.419,3.412,2.786Zm176.525.039-.513-.649q1.726-1.365,3.408-2.782l.532.634q-1.691,1.424-3.427,2.8m-169.41,5.243q-1.818-1.265-3.6-2.586l.493-.666q1.769,1.313,3.578,2.571Zm162.3.026-.473-.68q1.807-1.255,3.573-2.565l.493.666q-1.775,1.317-3.594,2.579m-154.871,4.8q-1.9-1.151-3.755-2.357l.452-.694q1.848,1.2,3.732,2.344Zm147.457.011-.428-.708q1.88-1.141,3.723-2.337l.45.694q-1.851,1.2-3.745,2.35m-7.695,4.344-.383-.733q1.947-1.022,3.857-2.1l.407.721c-1.289.728-2.594,1.439-3.882,2.112m-132.04.006q-1.967-1.03-3.9-2.12l.407-.722q1.919,1.083,3.874,2.109Zm124.1,3.852-.338-.756c1.34-.6,2.679-1.224,3.979-1.855l.362.744c-1.306.635-2.654,1.263-4,1.867m-116.112.022c-1.345-.6-2.7-1.233-4.022-1.876l.362-.744c1.315.638,2.661,1.265,4,1.862Zm107.935,3.334-.291-.776c1.365-.51,2.743-1.051,4.1-1.607l.315.765c-1.363.561-2.75,1.1-4.121,1.618m-99.72.031q-2.083-.78-4.136-1.62l.315-.766q2.039.835,4.109,1.609Zm91.333,2.81-.241-.79q2.108-.644,4.191-1.349l.266.785q-2.095.709-4.216,1.355m-82.917.035c-1.42-.431-2.844-.887-4.232-1.357l.265-.785c1.38.468,2.794.922,4.206,1.35Zm74.37,2.278-.19-.806c1.413-.334,2.848-.7,4.266-1.083l.216.8c-1.425.385-2.87.753-4.292,1.089m-65.822.028c-1.416-.335-2.862-.7-4.295-1.086l.216-.8c1.424.383,2.859.746,4.268,1.079Zm57.147,1.743-.14-.816c1.452-.25,2.907-.523,4.325-.814l.166.811c-1.426.291-2.89.566-4.351.818m-48.471.02c-1.465-.249-2.929-.524-4.352-.815l.166-.81c1.415.287,2.87.56,4.327.81Zm39.7,1.209-.091-.824q2.2-.239,4.37-.542l.115.819q-2.188.306-4.394.546m-30.933.013c-1.466-.158-2.944-.34-4.4-.542l.115-.82c1.441.2,2.911.382,4.369.539Zm22.107.668-.039-.828q2.206-.1,4.393-.27l.065.826c-1.461.114-2.949.205-4.419.273m-13.278.007c-1.483-.067-2.97-.158-4.422-.27l.065-.826c1.442.112,2.92.2,4.393.268Zm6.581.149c-.722,0-1.44-.006-2.157-.017l.012-.828c1.466.022,2.939.021,4.4,0l.012.828c-.755.012-1.514.018-2.271.019",
    transform: "translate(179.718 1.155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(766.959 2.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M-.176-.489Q-.6-1.509-1.024-2.525l.764-.32Q.167-1.827.589-.806Z",
    transform: "translate(1.024 2.845)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(31.061 8.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M-153.719-.914q-.793-2.052-1.609-4.094l.769-.307q.816,2.047,1.611,4.1Zm-713.724.221-.772-.3q.792-2.058,1.61-4.107l.77.307q-.816,2.044-1.607,4.1m716.8,8.021q-.747-2.07-1.514-4.129l.776-.289q.768,2.062,1.516,4.138Zm-719.87.232-.779-.28q.747-2.077,1.516-4.143l.776.289q-.768,2.06-1.513,4.134m722.751,8.078q-.7-2.088-1.418-4.163l.783-.272q.722,2.08,1.419,4.172Zm-725.63.244-.785-.262q.7-2.095,1.419-4.179l.783.272q-.72,2.078-1.416,4.169m728.316,8.13q-.646-2.1-1.319-4.2l.789-.253q.672,2.1,1.321,4.2Zm-731,.258-.79-.244q.647-2.11,1.32-4.211l.789.252q-.671,2.1-1.319,4.2m733.494,8.175q-.6-2.116-1.221-4.224l.793-.234q.624,2.111,1.224,4.233Zm-735.983.27-.8-.224q.6-2.125,1.223-4.24l.794.234q-.621,2.111-1.219,4.231m738.28,8.217q-.55-2.13-1.124-4.25l.8-.216q.575,2.125,1.126,4.26Zm-740.575.287-.8-.205q.55-2.14,1.124-4.268l.8.215q-.575,2.125-1.123,4.258m742.675,8.252q-.5-2.141-1.025-4.275l.8-.2q.527,2.138,1.028,4.285Zm-744.77.3-.806-.188q.5-2.151,1.024-4.293l.8.2q-.525,2.136-1.023,4.284m746.671,8.283q-.45-2.153-.926-4.3l.809-.179q.475,2.149.927,4.308Zm-748.568.318-.81-.169q.449-2.163.926-4.316l.808.179q-.475,2.148-.924,4.306m750.268,8.308q-.4-2.163-.826-4.318l.813-.161q.426,2.161.828,4.328Zm-751.964.337-.815-.15q.4-2.173.826-4.337l.813.16q-.426,2.158-.824,4.327m753.465,8.325q-.349-2.171-.725-4.335l.816-.141q.376,2.169.728,4.345Zm-754.962.355-.818-.131q.349-2.183.726-4.355l.815.141q-.374,2.169-.723,4.345m756.265,8.339q-.3-2.179-.626-4.351l.819-.123q.325,2.176.626,4.361Zm-757.561.375-.819-.113q.3-2.189.624-4.371l.819.123q-.325,2.176-.624,4.361m758.662,8.347q-.25-2.186-.525-4.364l.821-.1q.275,2.184.527,4.374Zm-759.756.4-.823-.094q.25-2.194.523-4.383l.821.1q-.273,2.183-.521,4.374m760.657,8.347q-.2-2.191-.426-4.374l.824-.085q.225,2.188.426,4.384Zm-761.552.417-.824-.074q.2-2.2.423-4.4l.824.084q-.224,2.189-.423,4.385m762.252,8.345q-.149-2.2-.326-4.383l.827-.066q.174,2.193.325,4.392Zm-762.944.439-.826-.055q.149-2.206.321-4.4l.826.065q-.172,2.194-.321,4.394m763.445,8.334q-.1-2.2-.225-4.388l.826-.047q.126,2.2.227,4.4Zm-763.937.465-.828-.036q.1-2.209.222-4.412l.826.046q-.123,2.2-.22,4.4m764.238,8.319q-.05-2.2-.126-4.392l.828-.03q.076,2.2.126,4.4Zm-764.528.49-.828-.019q.048-2.211.121-4.414l.828.026q-.073,2.2-.121,4.406m764.632,8.3q0-2.2-.028-4.4l.828-.01q.027,2.2.028,4.409Zm-764.725.509h-.828v-.35q0-2.035.022-4.066l.828.008q-.022,2.027-.022,4.058Zm765.457,8.308-.828-.017q.046-2.2.072-4.4l.828.008q-.023,2.207-.072,4.408m-766.177.5q-.051-2.2-.078-4.4l.828-.011q.027,2.2.078,4.394Zm765.88,8.31-.828-.036q.1-2.2.172-4.4l.828.029q-.073,2.206-.172,4.4m-765.575.492q-.1-2.2-.178-4.406l.828-.029q.076,2.2.178,4.4Zm765.079,8.313-.826-.056q.149-2.193.273-4.392l.826.046q-.124,2.2-.273,4.4m-764.571.491q-.152-2.2-.278-4.4l.826-.047q.126,2.2.278,4.392Zm763.875,8.3-.824-.074q.2-2.189.372-4.385l.826.066q-.174,2.2-.374,4.393m-763.166.492q-.2-2.194-.38-4.394l.826-.065q.176,2.194.378,4.383Zm762.269,8.28-.824-.094q.248-2.183.473-4.374l.824.084q-.224,2.2-.473,4.384m-761.362.491q-.253-2.188-.48-4.383l.825-.085q.225,2.189.477,4.373Zm760.264,8.259-.82-.111q.3-2.179.573-4.363l.821.1q-.275,2.191-.574,4.372m-759.153.489q-.3-2.181-.581-4.372l.822-.1q.277,2.186.577,4.362Zm757.852,8.234-.817-.132q.349-2.168.673-4.346l.819.121q-.325,2.183-.676,4.357m-756.542.487q-.353-2.174-.68-4.356l.819-.123q.328,2.178.679,4.346Zm755.041,8.2-.815-.15q.4-2.161.775-4.331l.816.141q-.376,2.174-.776,4.34m-753.528.486q-.4-2.164-.782-4.34l.816-.142q.378,2.169.78,4.331Zm751.827,8.168-.81-.17q.452-2.151.874-4.311l.813.159q-.426,2.166-.877,4.322m-750.116.482q-.452-2.156-.882-4.321l.814-.16q.427,2.159.88,4.311Zm748.217,8.129-.807-.188q.5-2.141.973-4.291l.809.179q-.477,2.154-.975,4.3m-746.3.48q-.5-2.145-.982-4.3l.808-.18q.48,2.149.979,4.289Zm744.2,8.085-.8-.205q.548-2.13,1.073-4.268l.8.2q-.525,2.143-1.075,4.276m-742.094.478q-.551-2.133-1.081-4.276l.8-.2q.527,2.136,1.077,4.266Zm739.8,8.037-.8-.225q.6-2.115,1.17-4.242l.8.216q-.576,2.13-1.174,4.25m-737.487.474q-.6-2.12-1.18-4.249l.8-.216q.576,2.125,1.175,4.239Zm734.991,7.985-.792-.243q.646-2.1,1.27-4.214l.794.235q-.624,2.116-1.272,4.222m-732.486.47q-.649-2.1-1.276-4.221l.794-.235q.624,2.11,1.274,4.211Zm729.782,7.964-.785-.262q.7-2.095,1.373-4.2l.788.253q-.677,2.108-1.377,4.208m-727.081.432q-.7-2.09-1.376-4.191l.789-.253q.672,2.095,1.371,4.18Zm724.184,7.934-.778-.28q.745-2.077,1.469-4.165l.783.27q-.725,2.095-1.474,4.175m-721.288.4q-.75-2.072-1.473-4.158l.783-.272q.72,2.082,1.468,4.149Zm718.2,7.9-.772-.3q.795-2.058,1.565-4.128l.776.289q-.772,2.073-1.57,4.137m-715.113.362q-.795-2.055-1.568-4.121l.776-.291q.77,2.063,1.564,4.112Zm711.833,7.857-.766-.317q.841-2.037,1.66-4.089l.771.306q-.821,2.057-1.665,4.1m-708.554.33q-.843-2.035-1.664-4.084l.771-.309q.816,2.045,1.658,4.076Zm705.083,7.806-.758-.333q.889-2.019,1.755-4.049l.761.326q-.866,2.034-1.758,4.057M-861.3,291.3q-.886-2.005-1.75-4.027l.762-.326q.863,2.017,1.745,4.02Zm697.974,7.783-.751-.351q.936-2,1.848-4.006l.754.343q-.914,2.012-1.851,4.014m-694.335.214q-.932-1.989-1.843-3.989l.753-.342q.909,1.994,1.84,3.979Zm690.492,7.75-.742-.369q.982-1.976,1.941-3.962l.746.36q-.962,1.992-1.945,3.971m-686.667.162q-.977-1.967-1.935-3.947l.746-.36q.956,1.974,1.931,3.938Zm682.645,7.708-.733-.386q1.023-1.947,2.03-3.914l.737.376q-1.008,1.969-2.035,3.924m-678.639.116q-1.022-1.943-2.026-3.9l.737-.378q1,1.952,2.021,3.893Zm674.433,7.658-.723-.4q1.071-1.923,2.12-3.865l.729.394q-1.052,1.944-2.125,3.874m-670.249.074q-1.068-1.921-2.114-3.856l.729-.392q1.043,1.931,2.11,3.845Zm665.866,7.6-.713-.418q1.114-1.9,2.209-3.815l.718.412q-1.095,1.919-2.214,3.822m-661.5.04q-1.113-1.895-2.2-3.805l.72-.41q1.086,1.9,2.2,3.8Zm656.948,7.529-.705-.436q1.161-1.875,2.3-3.762l.709.427q-1.139,1.891-2.3,3.771m-652.41.008q-1.154-1.87-2.291-3.756l.71-.427q1.131,1.881,2.286,3.747Zm4.712,7.431q-1.2-1.843-2.377-3.7l.7-.444q1.177,1.855,2.374,3.7Zm642.969.021-.694-.452q1.2-1.846,2.381-3.708l.7.444q-1.179,1.865-2.385,3.716m-638.087,7.3q-1.242-1.818-2.463-3.649l.69-.459q1.219,1.828,2.456,3.64Zm633.188.044-.683-.468q1.242-1.817,2.465-3.651l.688.459q-1.224,1.838-2.47,3.66M-822.1,359.908q-1.282-1.787-2.546-3.591l.68-.475q1.259,1.8,2.538,3.584Zm623.074.064-.672-.484q1.283-1.788,2.547-3.592l.679.475q-1.265,1.81-2.554,3.6M-816.885,367q-1.325-1.759-2.629-3.534l.668-.49q1.3,1.774,2.622,3.526Zm612.63.081-.662-.5q1.325-1.762,2.631-3.534l.666.491q-1.308,1.777-2.634,3.54m-607.255,6.895q-1.361-1.729-2.707-3.473l.655-.5q1.343,1.739,2.7,3.464Zm601.866.093-.649-.513q1.365-1.729,2.708-3.471l.656.506q-1.348,1.747-2.715,3.479m-596.328,6.759q-1.4-1.7-2.788-3.411l.645-.519q1.381,1.711,2.782,3.4Zm590.779.1-.638-.529q1.4-1.694,2.788-3.406l.645.519q-1.388,1.717-2.794,3.416m-585.087,6.621q-1.442-1.664-2.866-3.346l.632-.535q1.421,1.681,2.859,3.341Zm579.384.113-.625-.544q1.442-1.661,2.865-3.342l.631.534q-1.426,1.684-2.871,3.352m-573.538,6.483q-1.48-1.633-2.942-3.281l.618-.55q1.459,1.646,2.937,3.274Zm567.686.114-.613-.556q1.477-1.628,2.939-3.276l.619.551q-1.464,1.649-2.945,3.281m-561.69,6.345q-1.517-1.6-3.015-3.213l.607-.563q1.494,1.613,3.01,3.207Zm555.688.116-.6-.571q1.515-1.593,3.014-3.2l.6.563q-1.5,1.615-3.019,3.213m-549.545,6.207q-1.555-1.563-3.089-3.143l.593-.577q1.532,1.577,3.082,3.136Zm543.4.115-.587-.584q1.553-1.558,3.086-3.136l.593.578q-1.535,1.58-3.091,3.142m-537.111,6.066q-1.59-1.525-3.162-3.072l.58-.591q1.57,1.543,3.156,3.066Zm530.822.112-.573-.6q1.585-1.524,3.154-3.064l.581.591q-1.573,1.543-3.162,3.07m-524.4,5.925q-1.623-1.49-3.23-3l.566-.6q1.6,1.505,3.225,2.993Zm517.97.107-.561-.611q1.621-1.485,3.224-2.991l.567.6q-1.606,1.507-3.23,3m-511.4,5.783q-1.658-1.454-3.3-2.926l.552-.617q1.638,1.469,3.293,2.92Zm504.837.1-.545-.623q1.654-1.451,3.291-2.917l.552.617q-1.639,1.469-3.3,2.922m-498.137,5.64q-1.694-1.414-3.368-2.851l.539-.629q1.673,1.432,3.359,2.844Zm491.443.088-.53-.636q1.684-1.408,3.355-2.838l.539.629q-1.674,1.434-3.364,2.845m-484.613,5.5q-1.724-1.376-3.431-2.773l.524-.64q1.7,1.394,3.425,2.767Zm477.792.077-.516-.647q1.717-1.369,3.419-2.761l.523.64q-1.7,1.394-3.427,2.768m-470.833,5.35q-1.754-1.336-3.494-2.693l.509-.654q1.737,1.353,3.487,2.688Zm463.888.066-.5-.66q1.747-1.331,3.48-2.682l.509.654q-1.735,1.353-3.488,2.688m-456.806,5.2q-1.785-1.3-3.557-2.615l.495-.664q1.769,1.315,3.55,2.608Zm449.739.05-.487-.67q1.777-1.29,3.541-2.6l.493.664q-1.765,1.313-3.547,2.607m-442.535,5.055q-1.818-1.257-3.618-2.533l.479-.676q1.8,1.273,3.608,2.526Zm435.35.033-.469-.681q1.8-1.249,3.6-2.518l.479.676q-1.8,1.272-3.607,2.524M-720.92,457.1q-1.843-1.214-3.674-2.449l.464-.686q1.827,1.23,3.666,2.442Zm420.735.019-.455-.692q1.835-1.207,3.654-2.434l.464.686q-1.825,1.23-3.663,2.441m-413.3,4.749q-1.873-1.171-3.73-2.363l.446-.7q1.855,1.189,3.724,2.358Zm405.9,0-.439-.7q1.861-1.166,3.708-2.35l.447.7q-1.851,1.187-3.716,2.355m-7.514,4.579-.422-.712q1.886-1.12,3.76-2.263l.431.707q-1.876,1.146-3.769,2.269m-390.839.018q-1.9-1.129-3.786-2.279l.432-.708q1.883,1.149,3.777,2.274Zm383.229,4.387-.405-.722q1.911-1.078,3.81-2.175l.414.716q-1.9,1.1-3.819,2.18m-375.582.036q-1.924-1.085-3.836-2.19l.414-.715q1.908,1.1,3.83,2.184Zm367.872,4.192-.39-.731q1.936-1.032,3.857-2.088l.4.728q-1.928,1.055-3.866,2.091m-360.123.056q-1.951-1.04-3.887-2.1l.4-.727q1.931,1.061,3.88,2.1Zm352.32,3.993-.373-.74q1.961-.987,3.9-2l.382.735q-1.949,1.01-3.913,2m-344.469.075q-1.976-1-3.937-2.011l.382-.735q1.954,1.015,3.927,2.007ZM-346.12,483l-.357-.749q1.982-.941,3.949-1.906l.364.744q-1.972.966-3.957,1.91m-328.637.095q-2-.949-3.983-1.92l.365-.744q1.979.969,3.973,1.915Zm320.66,3.586-.339-.754q2-.9,3.99-1.815l.347.753q-1.992.917-4,1.816m-312.631.116q-2.017-.9-4.026-1.828l.347-.752q2,.924,4.019,1.823Zm304.574,3.382-.321-.763q2.022-.848,4.03-1.721l.329.759q-2.01.874-4.037,1.725m-296.455.132q-2.04-.854-4.068-1.734l.328-.759q2.025.876,4.062,1.731Zm288.3,3.184-.3-.769q2.048-.808,4.085-1.636l.312.768q-2.042.83-4.094,1.637m-280.1.144q-2.063-.808-4.11-1.639l.312-.768q2.044.831,4.1,1.636Zm271.859,2.991-.285-.778q2.067-.757,4.121-1.54l.3.774q-2.06.783-4.132,1.544m-263.583.145q-2.078-.762-4.148-1.546l.293-.774q2.067.782,4.139,1.541Zm255.27,2.8-.267-.785q2.085-.709,4.157-1.443l.276.781q-2.077.737-4.165,1.447m-246.921.147q-2.1-.714-4.184-1.448l.276-.781q2.082.734,4.174,1.444Zm238.54,2.6-.248-.789q2.1-.661,4.189-1.346l.258.787q-2.093.686-4.2,1.348m-230.121.149q-2.113-.662-4.217-1.35l.256-.787q2.1.686,4.21,1.348Zm221.68,2.4-.231-.8q2.113-.611,4.218-1.25l.24.794q-2.108.638-4.227,1.252m-213.217.143q-2.121-.613-4.232-1.246l.24-.794q2.1.634,4.222,1.244Zm204.719,2.212-.212-.8q2.128-.565,4.246-1.151l.222.8q-2.123.588-4.256,1.154m-196.218.131q-2.133-.561-4.257-1.147l.22-.8q2.12.583,4.249,1.145Zm187.669,2.028-.194-.8q2.143-.515,4.272-1.052l.2.8q-2.136.541-4.281,1.055m-179.115.12q-2.146-.513-4.282-1.049l.2-.8q2.131.533,4.274,1.044Zm170.516,1.838-.176-.808q2.15-.467,4.3-.954l.183.807q-2.148.49-4.3.955m-161.916.109q-2.156-.464-4.306-.948l.183-.808q2.143.485,4.3.947Zm153.273,1.652-.155-.814q2.161-.416,4.316-.853l.166.81q-2.158.442-4.327.857m-144.627.1q-2.168-.412-4.327-.85l.163-.81q2.156.434,4.318.847Zm135.948,1.463-.136-.817q2.171-.363,4.334-.753l.147.815q-2.168.391-4.345.755m-127.267.085q-2.179-.364-4.345-.75l.145-.815q2.164.386,4.337.747Zm118.555,1.274-.118-.819q2.179-.313,4.351-.652l.128.817q-2.176.343-4.361.655M-565.2,516.1q-2.184-.313-4.362-.649l.127-.817q2.173.334,4.352.646Zm101.1,1.085-.1-.821q2.186-.263,4.364-.553l.108.821q-2.183.29-4.373.553m-92.353.062q-2.191-.262-4.375-.548l.108-.823q2.179.286,4.366.549Zm83.586.894-.08-.824q2.191-.214,4.376-.453l.091.824q-2.189.24-4.387.453m-74.818.05q-2.2-.212-4.386-.447l.088-.824q2.184.235,4.377.447Zm66.03.709-.061-.826q2.2-.164,4.386-.353l.072.826q-2.2.19-4.4.353m-57.244.036q-2.2-.161-4.4-.346l.071-.827q2.189.187,4.386.347Zm48.445.517-.043-.826q2.2-.114,4.394-.253l.052.826q-2.2.139-4.4.253m-39.642.028q-2.206-.111-4.4-.246l.052-.827q2.191.137,4.392.245Zm30.845.327-.024-.828q2.194-.063,4.383-.152l.034.828q-2.194.089-4.393.152m-22.033.016q-2.206-.061-4.407-.147l.033-.828q2.2.086,4.4.147Zm13.226.14-.007-.828q2.2-.015,4.4-.053l.014.828q-2.2.038-4.406.053m-4.409,0q-2.207-.012-4.409-.046l.013-.828q2.2.035,4.4.046Z",
    transform: "translate(893.728 5.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(59.945 2.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M-.159-.489-.924-.8Q-.5-1.827-.075-2.844l.764.32Q.262-1.507-.159-.489",
    transform: "translate(0.924 2.844)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(599.066 1.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M-.285-.466Q-.965-1.33-1.655-2.19l.645-.518q.692.861,1.377,1.73Z",
    transform: "translate(1.655 2.708)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(176.552 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M-9.694-.836l-.668-.489q1.308-1.782,2.648-3.537l.658.5Q-8.392-2.612-9.694-.836m382.532.647q-1.3-1.779-2.626-3.532l.66-.5q1.333,1.759,2.635,3.544ZM-14.777,6.357l-.686-.465q1.242-1.83,2.517-3.633l.677.477q-1.272,1.8-2.508,3.621m392.669.659Q376.659,5.19,375.4,3.39l.678-.476q1.267,1.807,2.5,3.639Zm-397.48,6.719-.7-.44q1.172-1.873,2.379-3.724l.694.452q-1.2,1.845-2.372,3.713m402.261.668q-1.163-1.871-2.356-3.716l.693-.45q1.2,1.853,2.366,3.728ZM-24.12,21.287l-.719-.413q1.1-1.916,2.241-3.81l.709.426q-1.133,1.886-2.231,3.8m411.3.675q-1.091-1.911-2.217-3.8l.711-.424q1.129,1.894,2.225,3.813ZM-28.372,29l-.733-.385q1.03-1.956,2.1-3.892l.725.4q-1.065,1.929-2.09,3.877m419.769.679q-1.022-1.951-2.074-3.881l.726-.4q1.058,1.936,2.081,3.893Zm-423.729,7.19-.746-.358q.957-2,1.95-3.968l.74.372q-.989,1.967-1.943,3.953m427.657.681q-.946-1.989-1.928-3.955l.742-.37q.985,1.974,1.934,3.969ZM-36,44.886l-.76-.33q.883-2.029,1.8-4.038l.753.344q-.916,2-1.8,4.024m434.954.679q-.871-2.022-1.779-4.023l.755-.342q.909,2.009,1.785,4.037ZM-39.357,53.031l-.772-.3q.8-2.06,1.648-4.1l.765.316q-.84,2.034-1.642,4.088m441.646.673q-.8-2.053-1.627-4.086l.766-.315q.833,2.042,1.633,4.1ZM-42.412,61.3l-.783-.272q.729-2.09,1.495-4.162l.776.286q-.763,2.067-1.488,4.148m447.722.664q-.715-2.08-1.473-4.142l.778-.285q.757,2.07,1.477,4.158ZM-45.155,69.675l-.792-.243q.651-2.116,1.336-4.216l.787.257q-.682,2.092-1.331,4.2m453.177.651q-.641-2.1-1.316-4.194l.787-.256q.679,2.1,1.32,4.211Zm-455.6,7.823-.8-.213q.571-2.14,1.178-4.264l.8.227q-.6,2.118-1.174,4.249m458,.635q-.561-2.128-1.159-4.24l.8-.225q.6,2.12,1.164,4.255ZM-49.69,86.711l-.807-.183q.489-2.159,1.017-4.306l.8.2q-.527,2.138-1.013,4.29m462.187.614q-.479-2.146-1-4.28l.8-.194q.522,2.14,1,4.295ZM-51.478,95.346l-.813-.153q.407-2.178.856-4.341l.811.168q-.447,2.156-.854,4.327m465.733.59q-.4-2.164-.838-4.313l.81-.166q.442,2.156.842,4.329Zm-467.194,8.108-.819-.121q.328-2.193.693-4.372l.817.137q-.366,2.173-.691,4.356m468.63.563q-.32-2.179-.678-4.342l.817-.135q.359,2.171.681,4.355Zm-469.766,8.185-.824-.092q.245-2.2.529-4.4l.821.107q-.283,2.184-.527,4.38m470.877.528q-.237-2.186-.514-4.362l.821-.1q.278,2.183.517,4.377Zm-471.69,8.259-.826-.062q.164-2.211.367-4.412l.825.075q-.2,2.194-.365,4.4m472.479.49q-.157-2.2-.353-4.378l.824-.074q.2,2.191.355,4.393ZM-55.374,130.39l-.828-.03q.081-2.217.2-4.424l.826.045q-.121,2.2-.2,4.408m473.431.448q-.076-2.2-.192-4.387l.826-.044q.119,2.2.194,4.4Zm-473.593,8.377h-.828q0-2.219.042-4.429l.828.017q-.043,2.2-.042,4.413m474.569.418h-.828v-.387q0-2.014-.033-4.016l.828-.014q.033,2.01.033,4.031ZM-56.2,148.039q-.079-2.2-.119-4.407l.828-.015q.04,2.2.119,4.392Zm475.064.425-.828-.031q.081-2.2.127-4.4l.828.015q-.043,2.212-.127,4.415m-474.58,8.395q-.161-2.2-.282-4.408l.826-.045q.121,2.2.282,4.394Zm474.08.425-.826-.062q.164-2.191.289-4.393l.826.046q-.124,2.209-.289,4.408m-473.273,8.372q-.242-2.191-.444-4.4l.824-.075q.2,2.194.444,4.378Zm472.449.423-.824-.093q.247-2.183.452-4.377l.825.076q-.205,2.2-.453,4.394m-471.317,8.339q-.323-2.183-.606-4.376l.821-.1q.282,2.184.6,4.359Zm470.167.421-.819-.124q.326-2.173.614-4.359l.821.108q-.29,2.193-.616,4.374m-468.707,8.291q-.406-2.168-.772-4.351l.818-.136q.361,2.174.766,4.334Zm467.231.418-.813-.153q.407-2.161.775-4.333l.818.138q-.371,2.181-.781,4.349M-50.539,191.78q-.485-2.151-.932-4.317l.811-.168q.444,2.158.928,4.3Zm463.654.415-.807-.183q.487-2.143.936-4.3l.81.168q-.45,2.166-.94,4.316m-461.548,8.164q-.566-2.131-1.092-4.28l.8-.2q.525,2.14,1.089,4.265Zm459.428.413-.8-.213q.566-2.125,1.1-4.264l.8.2q-.533,2.146-1.1,4.278m-457,8.082q-.644-2.11-1.252-4.236l.795-.229q.609,2.12,1.249,4.222Zm454.562.407-.792-.244q.647-2.1,1.256-4.218l.795.229q-.611,2.125-1.26,4.234m-451.821,7.99q-.725-2.085-1.409-4.186l.786-.256q.684,2.093,1.405,4.171Zm449.056.435-.782-.273q.727-2.083,1.416-4.184l.787.258q-.692,2.108-1.422,4.2m-446,7.854q-.8-2.055-1.564-4.13l.776-.287q.762,2.068,1.561,4.117ZM402.7,226l-.769-.3q.806-2.053,1.573-4.126l.776.288q-.77,2.08-1.58,4.141m-439.563,7.7q-.876-2.017-1.712-4.054l.765-.315q.833,2.03,1.706,4.04Zm436.175.49-.758-.33q.881-2.022,1.726-4.064l.766.317q-.848,2.049-1.733,4.077M-33.21,241.7q-.949-1.984-1.862-3.989l.752-.343q.911,2,1.857,3.976Zm428.831.531-.746-.36q.959-1.987,1.878-3.994l.753.346q-.924,2.014-1.885,4.009m-424.884,7.342q-1.022-1.949-2.01-3.919l.74-.371q.985,1.962,2,3.9Zm420.9.562-.733-.386q1.03-1.949,2.025-3.919l.74.373q-1,1.976-2.031,3.932M-25.021,257.3q-1.095-1.909-2.156-3.842l.726-.4q1.057,1.926,2.148,3.829Zm412.375.587-.719-.414q1.1-1.909,2.169-3.84l.724.4q-1.07,1.939-2.175,3.854M-20.5,264.865q-1.166-1.87-2.3-3.762l.71-.425q1.129,1.886,2.292,3.749Zm403.285.6-.7-.44q1.172-1.866,2.31-3.755l.709.426q-1.141,1.9-2.317,3.769m-398.482,6.792q-1.234-1.827-2.438-3.673l.694-.454q1.2,1.845,2.43,3.663Zm393.64.611-.683-.465q1.239-1.822,2.446-3.666l.692.453q-1.211,1.853-2.455,3.679m-388.564,6.6q-1.3-1.779-2.571-3.584l.677-.477q1.265,1.8,2.563,3.571Zm383.454.613-.666-.492q1.3-1.772,2.58-3.57l.675.478q-1.278,1.805-2.589,3.585m-378.113,6.41q-1.368-1.731-2.7-3.488l.659-.5q1.331,1.752,2.694,3.474Zm372.736.609-.647-.516q1.371-1.724,2.71-3.472l.658.5q-1.346,1.752-2.721,3.483M.322,293.316q-1.431-1.681-2.832-3.386l.64-.526q1.4,1.7,2.822,3.375Zm361.509.6-.627-.539q1.432-1.671,2.835-3.369l.638.528q-1.406,1.7-2.846,3.38M6.169,299.929q-1.492-1.626-2.955-3.281l.622-.548q1.457,1.648,2.944,3.268Zm349.788.586-.608-.56q1.494-1.62,2.958-3.262l.619.551q-1.471,1.649-2.969,3.271m-343.7,5.807q-1.553-1.57-3.075-3.17l.6-.572q1.519,1.6,3.064,3.16Zm337.584.571-.586-.585q1.552-1.56,3.075-3.149l.6.573q-1.527,1.593-3.086,3.161m-331.261,5.6q-1.608-1.514-3.189-3.055l.577-.593q1.575,1.535,3.18,3.044Zm324.917.546-.565-.606q1.606-1.5,3.188-3.032l.575.6q-1.585,1.535-3.2,3.043M25.133,318.42q-1.666-1.452-3.3-2.934l.556-.615q1.631,1.479,3.29,2.927Zm311.8.52-.542-.626q1.663-1.441,3.3-2.91l.554.614q-1.643,1.477-3.31,2.922M31.9,324.105q-1.716-1.389-3.409-2.812l.532-.635q1.687,1.418,3.4,2.8Zm298.263.49-.518-.645q1.714-1.378,3.4-2.786l.531.636q-1.694,1.413-3.415,2.8M38.872,329.538q-1.769-1.325-3.511-2.684l.508-.654q1.735,1.353,3.5,2.676ZM323.185,330l-.5-.663q1.767-1.315,3.5-2.66l.507.655q-1.744,1.35-3.513,2.668M46.041,334.711q-1.817-1.262-3.609-2.554l.485-.671q1.785,1.287,3.6,2.544Zm269.973.424-.469-.681q1.808-1.247,3.595-2.527l.484.672q-1.792,1.283-3.609,2.536M53.4,339.615q-1.863-1.191-3.7-2.417l.459-.69q1.833,1.222,3.691,2.411ZM308.661,340l-.444-.7q1.855-1.177,3.686-2.39l.457.69q-1.838,1.219-3.7,2.4M60.942,344.246q-1.906-1.123-3.791-2.281l.433-.7q1.88,1.151,3.779,2.271Zm240.2.346-.418-.713q1.895-1.111,3.77-2.253l.432.707q-1.881,1.148-3.783,2.26m-232.484,4q-1.949-1.052-3.876-2.136l.405-.723q1.921,1.083,3.863,2.131Zm224.8.306-.392-.73q1.936-1.037,3.851-2.11l.405.723q-1.921,1.075-3.864,2.116M76.52,352.648q-1.987-.98-3.953-1.993l.379-.735q1.961,1.01,3.941,1.984Zm209.089.264-.364-.744q1.974-.965,3.925-1.964l.378.737q-1.959,1-3.938,1.971m-201.072,3.5q-2.022-.9-4.026-1.844l.351-.75q2,.936,4.014,1.837Zm193.093.223-.337-.756q2.007-.891,3.993-1.817l.35.751q-1.992.931-4.006,1.823M92.7,359.867q-2.058-.828-4.095-1.69l.323-.764q2.03.863,4.079,1.687Zm176.823.182-.306-.769q2.037-.813,4.056-1.665l.321.763q-2.025.854-4.072,1.671m-168.54,2.971q-2.088-.75-4.158-1.537l.3-.774q2.06.783,4.142,1.532Zm160.278.153-.278-.781q2.075-.74,4.131-1.518l.294.774q-2.063.782-4.147,1.525M109.38,365.86q-2.115-.671-4.214-1.381l.265-.785q2.092.71,4.2,1.377Zm143.5.128-.248-.789q2.1-.662,4.185-1.362l.263.785q-2.09.7-4.2,1.367m-135.035,2.385q-2.131-.59-4.245-1.217l.234-.794q2.108.624,4.232,1.213Zm126.562.114-.22-.8q2.126-.585,4.234-1.206l.235.794q-2.118.624-4.249,1.21m-118,2.081q-2.153-.51-4.289-1.058l.206-.8q2.128.546,4.273,1.053Zm109.445.1-.189-.806q2.145-.5,4.274-1.044l.205.8q-2.138.545-4.29,1.049M135.04,372.44q-2.171-.429-4.325-.9l.174-.808q2.149.464,4.31.891Zm92.174.083-.16-.813q2.164-.424,4.312-.885l.174.808q-2.158.465-4.327.89m-83.478,1.465q-2.186-.346-4.356-.734l.145-.815q2.166.386,4.341.732Zm74.776.068-.129-.818q2.178-.344,4.342-.724l.145.815q-2.173.384-4.357.728m-66.03,1.156q-2.2-.267-4.38-.572l.114-.819q2.178.3,4.365.569Zm57.28.049-.1-.821q2.191-.26,4.366-.56l.113.819q-2.183.3-4.382.562m-48.492.85q-2.2-.185-4.4-.408l.084-.824q2.186.224,4.383.406Zm39.7.035-.066-.826q2.2-.179,4.383-.4l.083.824q-2.194.22-4.4.4m-30.889.539q-2.209-.106-4.409-.247l.053-.826q2.194.142,4.4.245Zm22.073.02-.036-.828q2.2-.1,4.4-.237l.052.826q-2.2.139-4.41.24m-13.244.229q-2.212-.023-4.416-.084l.023-.828q2.194.061,4.4.084Zm4.417,0-.007-.828q2.2-.018,4.4-.076l.022.828q-2.2.058-4.413.076",
    transform: "translate(56.364 4.863)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(228.045 1.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M-.135-.465-.784-.98Q-.1-1.846.6-2.7l.643.521Q.549-1.327-.135-.465",
    transform: "translate(0.784 2.704)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(319.797 56.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M-19.132-.178l-.02-.828c1.474-.035,2.957-.039,4.426-.007l-.017.828c-1.459-.032-2.929-.03-4.39.007M-5.988.408C-7.431.243-8.9.108-10.358.01l.056-.826c1.468.1,2.952.234,4.408.4Zm-21.9.036-.1-.822c1.451-.171,2.933-.311,4.407-.417l.057.826c-1.459.1-2.929.244-4.367.414M2.672,1.816C1.246,1.514-.2,1.244-1.642,1.01l.134-.817C-.06.428,1.405.7,2.842,1.006Zm-39.212.066-.174-.809c1.434-.308,2.9-.586,4.35-.828l.136.817c-1.44.238-2.889.514-4.311.82m47.7,2.151C9.774,3.6,8.355,3.193,6.945,2.824l.21-.8c1.422.371,2.855.782,4.255,1.219Zm-56.185.095-.251-.788c1.4-.444,2.834-.859,4.253-1.234l.211.8c-1.405.372-2.823.784-4.213,1.222M19.426,7.049c-1.351-.566-2.729-1.106-4.1-1.605l.285-.777c1.379.5,2.768,1.048,4.13,1.618Zm-72.67.11-.323-.762c1.352-.573,2.735-1.119,4.106-1.625l.287.777c-1.36.5-2.73,1.042-4.069,1.61m80.6,3.669c-1.287-.689-2.607-1.356-3.921-1.983l.355-.747c1.327.633,2.658,1.3,3.957,2Zm-88.5.121-.392-.729c1.289-.694,2.614-1.369,3.938-2l.358.746c-1.312.63-2.625,1.3-3.9,1.987M34.9,15.335c-1.214-.806-2.465-1.593-3.717-2.342l.425-.71c1.262.754,2.524,1.548,3.749,2.361Zm-103.552.128-.46-.689c1.229-.818,2.485-1.614,3.736-2.366l.427.709c-1.24.745-2.486,1.536-3.7,2.346M41.985,20.525c-1.136-.916-2.306-1.818-3.48-2.676l.489-.669c1.185.868,2.365,1.776,3.511,2.7Zm-117.7.138-.522-.643c1.138-.922,2.315-1.833,3.5-2.706l.492.666c-1.176.867-2.343,1.769-3.47,2.683M48.55,26.351c-1.04-1.013-2.121-2.018-3.215-2.99l.55-.618c1.1.978,2.194,1.993,3.242,3.015Zm-130.811.15-.58-.592c1.054-1.031,2.143-2.048,3.237-3.022l.55.618c-1.084.965-2.162,1.973-3.207,3m136.806,6.26c-.952-1.117-1.935-2.219-2.921-3.273l.6-.566c1,1.064,1.988,2.176,2.948,3.3Zm-142.786.166-.631-.535c.947-1.116,1.936-2.231,2.941-3.311l.606.564c-1,1.071-1.977,2.175-2.916,3.282M59.912,39.7c-.84-1.2-1.716-2.384-2.6-3.531l.656-.507c.9,1.157,1.777,2.355,2.624,3.562ZM-93.6,39.883l-.679-.475c.84-1.2,1.722-2.407,2.621-3.571l.655.506c-.889,1.155-1.763,2.346-2.6,3.541M64.607,47.1c-.725-1.268-1.486-2.531-2.261-3.756l.7-.443c.783,1.234,1.55,2.509,2.28,3.788Zm-162.891.215L-99,46.9c.722-1.271,1.487-2.551,2.275-3.8l.7.442c-.782,1.242-1.541,2.509-2.255,3.77M68.585,54.9c-.6-1.337-1.244-2.665-1.9-3.948l.737-.376c.66,1.294,1.3,2.634,1.915,3.983Zm-170.839.253-.755-.339c.6-1.342,1.244-2.689,1.909-4l.74.374c-.659,1.3-1.3,2.637-1.893,3.968M71.814,63.049c-.475-1.382-.986-2.767-1.52-4.117l.769-.3c.54,1.361,1.055,2.759,1.533,4.153Zm-177.282.29-.785-.267c.476-1.4.988-2.8,1.525-4.168l.769.3c-.53,1.351-1.038,2.741-1.509,4.131m179.73,8.134c-.339-1.408-.718-2.834-1.126-4.24l.8-.231c.412,1.419.794,2.858,1.134,4.279Zm-182.152.3-.807-.191c.34-1.435.716-2.876,1.122-4.282l.795.229c-.4,1.394-.774,2.822-1.11,4.245m183.8,8.321c-.206-1.441-.447-2.9-.72-4.329L76,75.609c.275,1.445.52,2.915.726,4.367Zm-185.413.3-.82-.115c.2-1.447.442-2.917.713-4.369l.813.152c-.268,1.439-.506,2.9-.705,4.331M76.738,88.829c-.07-1.446-.174-2.919-.312-4.377l.824-.078c.14,1.471.245,2.957.317,4.416Zm-187.046.306-.828-.038c.067-1.475.169-2.961.3-4.416l.824.075c-.132,1.443-.233,2.917-.3,4.378M77.576,97.845l-.828-.038c.067-1.464.1-2.94.1-4.388v-.2h.828v.2c0,1.468-.034,2.957-.1,4.433m-188.7.1c-.07-1.468-.1-2.958-.106-4.427h.828c0,1.457.036,2.933.106,4.39Zm187.881,8.708-.819-.115c.2-1.443.372-2.909.508-4.359l.824.076c-.136,1.463-.308,2.942-.512,4.4m-187.053.1c-.205-1.448-.379-2.928-.517-4.4l.824-.077c.137,1.456.309,2.922.512,4.359Zm185.415,8.595-.806-.191c.337-1.419.645-2.863.914-4.292l.813.153c-.27,1.443-.581,2.9-.921,4.33m-183.764.1c-.344-1.437-.656-2.894-.927-4.33l.813-.153c.27,1.423.58,2.867.92,4.29Zm181.311,8.4-.784-.266c.47-1.387.914-2.8,1.315-4.186l.8.23c-.406,1.4-.852,2.824-1.327,4.223m-178.848.1c-.475-1.391-.923-2.812-1.331-4.222l.8-.231c.4,1.4.849,2.806,1.318,4.185ZM69.41,132.118l-.754-.339c.6-1.339,1.176-2.7,1.707-4.053l.771.3c-.537,1.36-1.116,2.736-1.723,4.087m-172.347.07c-.607-1.346-1.185-2.715-1.72-4.069l.769-.3c.53,1.341,1.1,2.7,1.7,4.032ZM65.4,140.024l-.72-.408c.725-1.28,1.425-2.581,2.081-3.871l.737.375c-.66,1.3-1.367,2.614-2.1,3.9m-164.329.04c-.722-1.268-1.426-2.578-2.1-3.892l.737-.375c.663,1.3,1.362,2.6,2.078,3.857Zm159.593,7.452-.679-.475c.837-1.195,1.655-2.426,2.433-3.656l.7.442c-.786,1.243-1.612,2.484-2.455,3.69m-154.866.02c-.843-1.2-1.668-2.443-2.451-3.681l.7-.444c.777,1.228,1.594,2.456,2.431,3.651ZM55.25,154.527l-.631-.535c.937-1.1,1.867-2.253,2.763-3.412l.655.506c-.9,1.17-1.841,2.328-2.786,3.442m-144.047.011c-.952-1.121-1.889-2.278-2.784-3.438l.656-.506c.887,1.15,1.816,2.3,2.761,3.408ZM49.209,161l-.577-.592c1.041-1.018,2.074-2.073,3.067-3.139l.606.564c-1,1.075-2.045,2.141-3.1,3.166m-131.968.009c-1.049-1.025-2.09-2.09-3.1-3.165l.606-.565c1,1.066,2.028,2.123,3.068,3.139ZM42.6,166.883l-.522-.644c1.127-.911,2.252-1.866,3.346-2.838l.55.619c-1.1.98-2.238,1.943-3.374,2.863m-118.737.011c-1.139-.921-2.275-1.886-3.377-2.865l.55-.619c1.093.972,2.22,1.928,3.347,2.841Zm111.609,5.227-.459-.689c1.213-.807,2.422-1.653,3.595-2.514l.489.667c-1.181.869-2.4,1.722-3.624,2.536M-69,172.138c-1.217-.809-2.439-1.664-3.631-2.539l.489-.667c1.183.867,2.393,1.713,3.6,2.516Zm96.888,4.531-.393-.73c1.288-.693,2.571-1.422,3.811-2.165l.424.71c-1.249.75-2.541,1.485-3.842,2.185m-89.285.023c-1.295-.7-2.592-1.432-3.854-2.188l.424-.71c1.252.75,2.538,1.479,3.822,2.168Zm81.315,3.79-.321-.763c1.331-.562,2.675-1.166,3.992-1.8l.359.747c-1.331.636-2.686,1.245-4.03,1.813m-73.312.032c-1.36-.572-2.72-1.183-4.047-1.817l.358-.746c1.314.628,2.664,1.233,4.011,1.8Zm65.014,3.018-.248-.79c1.39-.437,2.786-.914,4.154-1.416l.284.777c-1.378.507-2.788.988-4.19,1.43m-56.682.034c-1.412-.443-2.825-.923-4.2-1.427l.285-.778c1.365.5,2.767.977,4.165,1.415Zm48.121,2.221-.173-.809c1.423-.3,2.859-.647,4.268-1.018l.211.8c-1.421.374-2.869.72-4.306,1.027m-39.559.024c-1.431-.3-2.881-.647-4.308-1.021l.21-.8c1.414.371,2.852.712,4.27,1.013Zm30.825,1.418-.1-.822c1.446-.17,2.908-.375,4.344-.613l.136.817c-1.448.24-2.923.447-4.384.618m-22.088.013c-1.472-.17-2.947-.376-4.384-.613l.134-.817c1.425.234,2.887.438,4.345.607Zm13.256.606-.019-.828c1.461-.034,2.936-.1,4.385-.205l.057.826c-1.462.1-2.95.172-4.424.208m-4.427,0c-1.476-.032-2.964-.1-4.422-.2l.056-.826c1.445.1,2.92.167,4.384.2Z",
    transform: "translate(111.232 1.035)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(358.917 69.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M-22.941-48.8V-224.741c0-32.451-24.849-59-55.22-59s-55.219,26.551-55.219,59V-48.8Z",
    transform: "translate(133.38 283.743)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M525.031-346.033H461.451v-89.333h63.581Z",
    transform: "translate(-79.368 626.882)",
    fill: "#f69571"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(382.082 189.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M-13.207-7.4C-42.586-.3-64.017-5.383-76.788-23.746V-43h63.581Z",
    transform: "translate(76.788 43.004)",
    fill: "#e57553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(256.909 241.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M-61.809-13.616c-12.27-18.889-111.516-65.549-111.516-65.549h-57.611s-99.247,46.659-111.516,65.549-16.906,90.934-16.906,90.934H-44.9s-4.636-72.044-16.9-90.934",
    transform: "translate(359.358 79.165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(256.909 250.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M-22.908,0c-29.236,14.446-84.428,42.984-93.375,56.76-12.27,18.891-16.906,90.934-16.906,90.934H-7.945Z",
    transform: "translate(133.189)",
    fill: "#01a9e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(445.662 250.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M-3.2,0c29.236,14.446,84.43,42.984,93.375,56.76,12.27,18.891,16.906,90.934,16.906,90.934h-125.7Z",
    transform: "translate(18.623)",
    fill: "#01a9e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(368.842 90.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M-16.25-1.337l-33.2-6.439-33.2,6.439L-94.478,37.495V81.242c6.692,20.752,19.711,41.058,45.03,40.96,25.318.1,38.336-20.208,45.03-40.96l-.008-43.747Z",
    transform: "translate(94.478 7.776)",
    fill: "#f69571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102",
    transform: "translate(360.089 74.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M0-13.479c27.787-2.743,47.977-14.405,54.258-37.81,10.13,24.777,27.665,35.98,54.065,37.81,0,0-4.229-76-54.161-63.5S0-13.479,0-13.479",
    transform: "translate(0 78.365)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106",
    transform: "translate(441.448 66.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M0,0,2.758,18.545a11.7,11.7,0,0,0,3.27-9.964A11.7,11.7,0,0,0,0,0",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "translate(444.206 78.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M-3.853-.706-22.4,2.053a11.7,11.7,0,0,1,8.583-6.029A11.7,11.7,0,0,1-3.853-.706",
    transform: "translate(22.399 4.105)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(379.435 229.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M-13.785-4.18H-77.05a3.094,3.094,0,0,1-3.093-3.095V-21.207A3.094,3.094,0,0,1-77.05-24.3h63.266a3.094,3.094,0,0,1,3.093,3.095V-7.274A3.094,3.094,0,0,1-13.785-4.18",
    transform: "translate(80.144 24.301)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(362.412 182.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M-9.87-3.453H-42.81A14.593,14.593,0,0,1-57.387-18.03v-2.047h2.208v2.047A12.382,12.382,0,0,0-42.81-5.661H-9.87Z",
    transform: "translate(57.387 20.077)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g122",
    transform: "translate(362.75 79.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M-.7-13.721H-4.079V-28.386A51.444,51.444,0,0,1,47.307-79.772,51.445,51.445,0,0,1,98.694-28.386V-14.2H95.317V-28.386A48.065,48.065,0,0,0,47.307-76.4,48.065,48.065,0,0,0-.7-28.386Z",
    transform: "translate(4.079 79.772)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(343.854 143.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M-1.437-5.662h2.7V-32.92h-2.7c-3.805,0-6.92,2.688-6.92,5.975v15.308c0,3.286,3.114,5.975,6.92,5.975",
    transform: "translate(8.357 32.92)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(351.386 130.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M-3.232,0h0c-8.558,0-15.561,6.047-15.561,13.437V40.4c0,7.39,7,13.437,15.561,13.437a1.781,1.781,0,0,0,1.9-1.637V1.637A1.781,1.781,0,0,0-3.232,0",
    transform: "translate(18.793)",
    fill: "#80c7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g134",
    transform: "translate(474.267 143.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M-.562,0h-2.7V27.258h2.7c3.805,0,6.92-2.688,6.92-5.975V5.975C6.358,2.689,3.244,0-.562,0",
    transform: "translate(3.267)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(458.902 130.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M-.394-11.182h0c8.558,0,15.561-6.047,15.561-13.437V-51.578c0-7.39-7-13.437-15.561-13.437a1.781,1.781,0,0,0-1.9,1.637V-12.82a1.781,1.781,0,0,0,1.9,1.637",
    transform: "translate(2.291 65.015)",
    fill: "#80c7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(398.865 194.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M-3.125-1.571H-14.388a3.792,3.792,0,0,1-3.781-3.781,3.793,3.793,0,0,1,3.781-3.781H-3.125A3.793,3.793,0,0,1,.656-5.352,3.792,3.792,0,0,1-3.125-1.571",
    transform: "translate(18.169 9.133)",
    fill: "#80c7a7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M445.788-459.09h-.828v-45.837h.828Z",
    transform: "translate(-76.532 638.846)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M554.556-459.09h-.828v-45.837h.828Z",
    transform: "translate(-95.24 638.846)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M424.706-465.791h-.828v-26.959h.828Z",
    transform: "translate(-72.906 636.752)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M575.639-465.791h-.828v-26.959h.828Z",
    transform: "translate(-98.866 636.752)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g154",
    transform: "translate(401.209 180.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M0,0H25.911A16.171,16.171,0,0,1,12.954,6.5,16.17,16.17,0,0,1,0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158",
    transform: "translate(406.776 188.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M-1.535-.492A12.774,12.774,0,0,1-8.923-2.86,9.308,9.308,0,0,0-1.535,1.067,9.3,9.3,0,0,0,5.853-2.86,12.768,12.768,0,0,1-1.535-.492",
    transform: "translate(8.923 2.86)",
    fill: "#e57553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(409.514 150.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M-2.221-4.823H-5.775c-3.936,0-7.14-2.668-7.14-5.947V-28.039h.828V-10.77c0,2.823,2.832,5.119,6.312,5.119h3.554Z",
    transform: "translate(12.915 28.039)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(388.94 152.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M-1.273-.637A3.064,3.064,0,0,1-4.338,2.428,3.065,3.065,0,0,1-7.4-.637,3.065,3.065,0,0,1-4.338-3.7,3.064,3.064,0,0,1-1.273-.637",
    transform: "translate(7.404 3.701)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170",
    transform: "translate(383.372 151.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M-.1-.829-.6-1.495C5.4-5.932,11.209-5.93,16.686-1.483l-.522.643C10.949-5.075,5.626-5.073-.1-.829",
    transform: "translate(0.596 4.82)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g174",
    transform: "translate(435.43 152.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M-1.273-.637A3.065,3.065,0,0,1-4.338,2.428,3.065,3.065,0,0,1-7.4-.637,3.065,3.065,0,0,1-4.338-3.7,3.065,3.065,0,0,1-1.273-.637",
    transform: "translate(7.404 3.701)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g178",
    transform: "translate(429.862 151.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M-.1-.829-.6-1.495C5.4-5.933,11.209-5.927,16.685-1.483l-.522.643C10.947-5.075,5.625-5.074-.1-.829",
    transform: "translate(0.596 4.82)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g182",
    transform: "translate(383.989 140.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M-3.331-.472c0,1.255-3.59,2.272-8.018,2.272S-19.365.783-19.365-.472s3.59-2.272,8.016-2.272S-3.331-1.727-3.331-.472",
    transform: "translate(19.365 2.744)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g186",
    transform: "translate(430.479 140.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M-3.331-.472C-3.331.783-6.92,1.8-11.348,1.8S-19.364.783-19.364-.472s3.589-2.272,8.016-2.272S-3.331-1.727-3.331-.472",
    transform: "translate(19.364 2.744)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g190",
    transform: "translate(364.89 131.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M-4.574-.172A21.213,21.213,0,0,0-25.763,21.017,21.213,21.213,0,0,0-4.574,42.205,21.212,21.212,0,0,0,16.614,21.017,21.212,21.212,0,0,0-4.574-.172m0,43.205A22.041,22.041,0,0,1-26.591,21.017,22.041,22.041,0,0,1-4.574-1,22.041,22.041,0,0,1,17.442,21.017,22.041,22.041,0,0,1-4.574,43.033",
    transform: "translate(26.591 1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g194",
    transform: "translate(419.133 131.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M-4.573-.172A21.212,21.212,0,0,0-25.761,21.017,21.212,21.212,0,0,0-4.573,42.205,21.213,21.213,0,0,0,16.616,21.017,21.213,21.213,0,0,0-4.573-.172m0,43.205A22.041,22.041,0,0,1-26.589,21.017,22.041,22.041,0,0,1-4.573-1,22.041,22.041,0,0,1,17.444,21.017,22.041,22.041,0,0,1-4.573,43.033",
    transform: "translate(26.589 1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g198",
    transform: "translate(407.32 143.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M-2.649-.87A8.3,8.3,0,0,0-9.328-4.22,6.95,6.95,0,0,0-14.715-.905l-.688-.46a7.753,7.753,0,0,1,6.03-3.681A9.162,9.162,0,0,1-2.016-1.4Z",
    transform: "translate(15.403 5.056)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "M527.656-371.2h-69.4v-.828h69.4Z",
    transform: "translate(-78.818 615.988)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g204",
    transform: "translate(510.953 331.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "M-.168-13.762l-.81-.168L12.739-80.014l.811.169Z",
    transform: "translate(0.979 80.014)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g208",
    transform: "translate(367.47 363.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M-16.765-5.056H-85.3A12.17,12.17,0,0,1-97.473-17.227,12.171,12.171,0,0,1-85.3-29.4h68.537A12.172,12.172,0,0,1-4.594-17.227,12.171,12.171,0,0,1-16.765-5.056",
    transform: "translate(97.473 29.399)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g212",
    transform: "translate(392.795 367.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "M-3.181-1.59a7.657,7.657,0,0,1-7.656,7.657A7.656,7.656,0,0,1-18.492-1.59a7.655,7.655,0,0,1,7.655-7.656A7.656,7.656,0,0,1-3.181-1.59",
    transform: "translate(18.492 9.247)",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(394.7 372.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M-2.29-.936a3.055,3.055,0,0,0,.363-.577,1.222,1.222,0,0,0,.106-.6A2.564,2.564,0,0,0-2.7-3.941a8.533,8.533,0,0,0-9.32-.23,2.647,2.647,0,0,0-1.2,1.573,2.9,2.9,0,0,0-.082.448.832.832,0,0,0,.152.657l.317.475a.455.455,0,0,0,.459.2,12.457,12.457,0,0,0,2.087-.556.352.352,0,0,0,.234-.343L-10.1-3.159a6.185,6.185,0,0,1,5.067-.01V-1.7a.382.382,0,0,0,.254.361,9.588,9.588,0,0,0,2.183.532.34.34,0,0,0,.3-.13",
    transform: "translate(13.317 5.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g220",
    transform: "translate(419.208 367.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "M-3.181-1.59a7.657,7.657,0,0,1-7.656,7.657A7.657,7.657,0,0,1-18.493-1.59a7.656,7.656,0,0,1,7.656-7.656A7.656,7.656,0,0,1-3.181-1.59",
    transform: "translate(18.493 9.247)",
    fill: "#80c7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g224",
    transform: "translate(421.659 371.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M-1.118-.009-4.435,1.723a.353.353,0,0,1-.168.042H-6.045a.545.545,0,0,0-.456.6v2.9a.545.545,0,0,0,.456.6H-4.6a.367.367,0,0,1,.168.042l3.316,1.733c.3.156.624-.135.624-.561V.551c0-.425-.325-.716-.624-.56",
    transform: "translate(6.501 0.052)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g228",
    transform: "translate(428.674 373.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "M-.049-.012A.463.463,0,0,0-.227.616a1.913,1.913,0,0,1,0,2.031.463.463,0,0,0,.174.629.448.448,0,0,0,.227.061.464.464,0,0,0,.4-.235,2.833,2.833,0,0,0,0-2.937A.464.464,0,0,0-.049-.012",
    transform: "translate(0.285 0.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "translate(430.402 372.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M-.18-.049A.463.463,0,0,0-.807-.227.462.462,0,0,0-.985.4a4.6,4.6,0,0,1,0,4.836.461.461,0,0,0,.173.628.435.435,0,0,0,.227.061.459.459,0,0,0,.4-.234,5.526,5.526,0,0,0,0-5.741",
    transform: "translate(1.044 0.285)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g236",
    transform: "translate(255.325 214.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "M-8.436-21.362C-27-16.809-31.531-27.41-37.819-41.514S-48.872-90.723-48.872-90.723c-1.4-9.267,6.083-10.692,6.976-8.068.322,1.308-.851-5.055-1.053-6.37-1.355-11.666,7.886-10.719,9.618-6.34-2.569-8.794,6.866-12.248,8.957-6.711-1.142-6.492,7.628-9.288,11-.138C-11.078-113.439,1.055-70.3,1.055-70.3,4.88-71.558-.177-88.246,8.886-92.438a1.683,1.683,0,0,1,1.966,1.292c4.688,25.929-.332,41.675-1.6,47.305C7.352-35.332,2.732-24.1-8.436-21.362",
    transform: "translate(49.045 124.198)",
    fill: "#f69571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g240",
    transform: "translate(261.83 240.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "M-1.476-5.395-8.583-31.147l.8-.22L-.678-5.615Z",
    transform: "translate(8.583 31.367)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g244",
    transform: "translate(270.482 227.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "M-1.692-7.207-9.839-41.713l.807-.19L-.886-7.4Z",
    transform: "translate(9.839 41.903)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g248",
    transform: "translate(279.728 220.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M-2.086-8.043-12.129-46.557l.8-.209L-1.284-8.252Z",
    transform: "translate(12.129 46.765)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g252",
    transform: "translate(265.594 258.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M-.078-2.148l-.378-.737c9.892-5.051,19.1-8.192,28.148-9.6l.128.818c-8.961,1.4-18.086,4.513-27.9,9.523",
    transform: "translate(0.456 12.489)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g256",
    transform: "translate(288.884 268.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M-.284-4.951c-1.978-5.56-1.808-10.418.508-14.438,4.264-7.4,14.172-9.32,14.592-9.4l.15.814c-.1.019-9.957,1.93-14.027,9C-1.248-15.173-1.4-10.549.5-5.229Z",
    transform: "translate(1.65 28.787)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g260",
    transform: "translate(261.075 303.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M-10.038-5.407-8-26.151l-47.082-5.285-3.278,22.8Z",
    transform: "translate(58.361 31.436)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g264",
    transform: "translate(246.491 315.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M-3.054,0l-14.7,82.506H42.98l4.891-76.18Z",
    transform: "translate(17.753)",
    fill: "#01a9e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g268",
    transform: "translate(306.812 321.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M-.172-15.836-1-15.89,3.893-92.07l.826.054Z",
    transform: "translate(0.997 92.07)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M638.742-185.61H288.918v-.828H638.742Z",
    transform: "translate(-49.693 584.067)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g274",
    transform: "translate(177.572 38.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M-30.68-14.747H-167.4a11.012,11.012,0,0,1-10.98-10.98V-74.758a11.012,11.012,0,0,1,10.98-10.98H-30.68A11.012,11.012,0,0,1-19.7-74.758v49.031a11.012,11.012,0,0,1-10.98,10.98",
    transform: "translate(178.376 85.738)",
    fill: "#01a9e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g278",
    transform: "translate(177.158 37.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M-23.859-14.919H-127.32a11.407,11.407,0,0,1-11.394-11.394V-75.344A11.407,11.407,0,0,1-127.32-86.738h19.73v.828h-19.73a10.578,10.578,0,0,0-10.566,10.566v49.031A10.578,10.578,0,0,0-127.32-15.747H-23.859Z",
    transform: "translate(138.714 86.738)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g282",
    transform: "translate(298.869 106.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M-4.539,0V14.943c0,3.347-3.66,5.029-5.81,2.668L-26.391,0Z",
    transform: "translate(26.391)",
    fill: "#01a9e0"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "text288",
    transform: "translate(187.399 -589.686)",
    fill: "#fff",
    fontSize: 23,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEED HELP?")), /*#__PURE__*/React.createElement("g", {
    id: "g290",
    transform: "translate(0 -666.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g292",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298",
    transform: "translate(75.067 92.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "M-7.927-9.1h-32.54a5.622,5.622,0,0,1-5.623-5.623v-32.54a5.622,5.622,0,0,1,5.623-5.623h32.54A5.622,5.622,0,0,1-2.3-47.259v32.54A5.622,5.622,0,0,1-7.927-9.1",
    transform: "translate(46.091 52.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g302",
    transform: "translate(74.653 91.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M-8.013-9.267h-32.54A6.044,6.044,0,0,1-46.591-15.3v-32.54a6.044,6.044,0,0,1,6.037-6.037h10.5v.828h-10.5a5.215,5.215,0,0,0-5.209,5.209V-15.3A5.215,5.215,0,0,0-40.554-10.1h32.54A5.215,5.215,0,0,0-2.8-15.3v-4.739h.828V-15.3A6.044,6.044,0,0,1-8.013-9.267",
    transform: "translate(46.591 53.881)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g306",
    transform: "translate(79.746 83.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M-3.8-9.367-22.092-27.29l4.636-4.733,12.492,12.24L17.4-54.463l5.567,3.59Z",
    transform: "translate(22.092 54.463)",
    fill: "#81c5a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g310",
    transform: "translate(75.067 158.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M-7.927-9.1h-32.54a5.622,5.622,0,0,1-5.623-5.623v-32.54a5.622,5.622,0,0,1,5.623-5.623h32.54A5.622,5.622,0,0,1-2.3-47.259v32.54A5.622,5.622,0,0,1-7.927-9.1",
    transform: "translate(46.091 52.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g314",
    transform: "translate(79.746 149.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "M-3.8-9.368-22.092-27.291l4.636-4.732,12.492,12.24L17.4-54.464l5.567,3.59Z",
    transform: "translate(22.092 54.464)",
    fill: "#81c5a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g318",
    transform: "translate(75.067 224.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M-7.927-9.1h-32.54a5.622,5.622,0,0,1-5.623-5.623v-32.54a5.622,5.622,0,0,1,5.623-5.623h32.54A5.622,5.622,0,0,1-2.3-47.259v32.54A5.622,5.622,0,0,1-7.927-9.1",
    transform: "translate(46.091 52.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g322",
    transform: "translate(79.746 215.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M-3.8-9.367-22.092-27.29l4.636-4.733,12.492,12.24L17.4-54.463l5.567,3.59Z",
    transform: "translate(22.092 54.463)",
    fill: "#81c5a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g326",
    transform: "translate(74.653 157.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M-8.013-9.267h-32.54A6.044,6.044,0,0,1-46.591-15.3v-32.54a6.044,6.044,0,0,1,6.037-6.037h10.5v.828h-10.5a5.215,5.215,0,0,0-5.209,5.209V-15.3A5.215,5.215,0,0,0-40.554-10.1h32.54A5.215,5.215,0,0,0-2.8-15.3v-4.739h.828V-15.3A6.044,6.044,0,0,1-8.013-9.267",
    transform: "translate(46.591 53.881)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g330",
    transform: "translate(74.653 223.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M-8.013-9.267h-32.54A6.044,6.044,0,0,1-46.591-15.3v-32.54a6.044,6.044,0,0,1,6.037-6.037h10.5v.828h-10.5a5.215,5.215,0,0,0-5.209,5.209V-15.3A5.215,5.215,0,0,0-40.554-10.1h32.54A5.215,5.215,0,0,0-2.8-15.3v-4.739h.828V-15.3A6.044,6.044,0,0,1-8.013-9.267",
    transform: "translate(46.591 53.881)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g334",
    transform: "translate(534.058 191.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M-20.089-14.345h-89.035A7.7,7.7,0,0,1-116.8-22.02V-75.725a7.7,7.7,0,0,1,7.676-7.675h89.035a7.7,7.7,0,0,1,7.674,7.675V-22.02a7.7,7.7,0,0,1-7.674,7.675",
    transform: "translate(116.801 83.4)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g338",
    transform: "translate(533.644 198.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M-18.083-12.836h-78.96a8.1,8.1,0,0,1-8.09-8.089V-74.63h.828v53.705a7.27,7.27,0,0,0,7.262,7.261h78.96Z",
    transform: "translate(105.133 74.63)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g342",
    transform: "translate(537.972 195.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M-10.013-6.505A15.651,15.651,0,0,1-19.073-9.39L-58.219-37.146l.479-.676,39.146,27.756a14.836,14.836,0,0,0,17.256-.068l38.4-27.685.485.671L-.852-9.463a15.655,15.655,0,0,1-9.161,2.958",
    transform: "translate(58.219 37.821)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g346",
    transform: "translate(539.392 214.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M-.146-8.454l-.7-.438,25.2-40.261.7.439Z",
    transform: "translate(0.849 49.153)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g350",
    transform: "translate(606.387 214.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M-5.234-8.454l-25.2-40.26.7-.439,25.2,40.261Z",
    transform: "translate(30.429 49.153)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g354",
    transform: "translate(620.694 184.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M-5.073-2.537A12.212,12.212,0,0,1-17.286,9.676,12.212,12.212,0,0,1-29.5-2.537,12.211,12.211,0,0,1-17.286-14.748,12.211,12.211,0,0,1-5.073-2.537",
    transform: "translate(29.497 14.748)",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g358",
    transform: "translate(626.732 188.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M-.368-1.788H4.907V-8.11Zm6.1,6.525H4.907V-.96H-2.139l7.874-9.435v8.607H7.823V-.96H5.735Z",
    transform: "translate(2.139 10.395)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g362",
    transform: "translate(65.311 435.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M-27.951-1.358V-7.9H-148.078A14.476,14.476,0,0,0-162.51,6.536v6.516a14.475,14.475,0,0,0,14.433,14.433H-27.951V-1.358Z",
    transform: "translate(162.51 7.897)",
    fill: "#ea984e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g366",
    transform: "translate(112.901 435.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M-3.353-6.031a7.81,7.81,0,0,1-7.787-7.787v-6.921a7.81,7.81,0,0,1,7.787-7.788H115.061v-6.539H-5.065A14.476,14.476,0,0,0-19.5-20.632v6.516A14.475,14.475,0,0,0-5.065.317H115.061V-6.031Z",
    transform: "translate(19.497 35.065)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(121.259 441.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M-24.633,0h-110.8a7.81,7.81,0,0,0-7.787,7.788v6.921A7.81,7.81,0,0,0-135.43,22.5h110.8Z",
    transform: "translate(143.217)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "M269.334-127.932H171.464v-.828h97.871Z",
    transform: "translate(-29.491 574.147)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M269.334-110.87H171.464v-.828h97.871Z",
    transform: "translate(-29.491 571.212)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M266.4-115.569h-112v-.828h112Z",
    transform: "translate(-26.557 572.02)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g380",
    transform: "translate(79.514 470.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "M-30.735-1.382V-8.033h-132.09c-8.729,0-15.871,6.607-15.871,14.682v1.74c0,8.075,7.142,14.682,15.871,14.682h132.09V-1.382Z",
    transform: "translate(178.697 8.033)",
    fill: "#4591b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g384",
    transform: "translate(163.474 470.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "M-3.688-5.12c-4.71,0-8.563-3.565-8.563-7.921v-2.152c0-4.356,3.853-7.922,8.563-7.922H98.505v-6.652H-5.57c-8.728,0-15.87,6.607-15.87,14.683v1.739C-21.44-5.27-14.3,1.339-5.57,1.339H98.505V-5.12Z",
    transform: "translate(21.44 29.767)",
    fill: "#5ba8c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g388",
    transform: "translate(172.664 477.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "M-21.267,0h-93.818c-4.71,0-8.563,3.565-8.563,7.922v2.152c0,4.356,3.853,7.921,8.563,7.921h93.818Z",
    transform: "translate(123.648)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "M315.643-85.082h-79.6v-.828h79.6Z",
    transform: "translate(-40.598 566.777)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "M315.643-73.632h-79.6v-.828h79.6Z",
    transform: "translate(-40.598 564.807)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M312.416-78.412H217.278v-.828h95.138Z",
    transform: "translate(-37.371 565.629)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g398",
    transform: "translate(121.806 346.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M-12.048-18.417H-64.666l-5.381-88.659h63.38Z",
    transform: "translate(70.046 107.076)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g402",
    transform: "translate(121.805 346.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M-13.112-.88l.257-4.238h-63.38l.142,2.353Z",
    transform: "translate(76.234 5.119)",
    fill: "#efe0d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g406",
    transform: "translate(121.344 366.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "M-12.865-8.1-10.5-47.123H-74.8L-72.431-8.1Z",
    transform: "translate(74.8 47.123)",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g410",
    transform: "translate(119.882 339.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M-.184-.421-1.071,4.7H66.156L65.3-.239a2.662,2.662,0,0,0-2.623-2.208H2.223A2.443,2.443,0,0,0-.184-.421",
    transform: "translate(1.071 2.447)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g414",
    transform: "translate(125.729 328.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M-11.216-.552a3.067,3.067,0,0,0-3.039-2.655H-60.6A3.314,3.314,0,0,0-63.887-.338l-1.325,9.781H-9.863Z",
    transform: "translate(65.212 3.207)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "translate(148.323 374.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M-2.552-.172A11.469,11.469,0,0,0-14.008,11.285,11.469,11.469,0,0,0-2.552,22.742,11.469,11.469,0,0,0,8.906,11.285,11.47,11.47,0,0,0-2.552-.172m0,23.742A12.3,12.3,0,0,1-14.836,11.285,12.3,12.3,0,0,1-2.552-1,12.3,12.3,0,0,1,9.734,11.285,12.3,12.3,0,0,1-2.552,23.57",
    transform: "translate(14.836 1)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g422",
    transform: "translate(120.904 366.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "M-7.084-8.277H-38.768l-2.42-39.846H15.3v.828H-40.308L-37.99-9.1H-7.084Z",
    transform: "translate(41.188 48.123)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g426",
    transform: "translate(604.272 290.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "M0-31.271S11.773-182.45,38.7-181.807,58.431-23.75,58.431-23.75Z",
    transform: "translate(0 181.809)",
    fill: "#51cb20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g430",
    transform: "translate(631.684 297.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "M-.61-35.313c-9.848-79.858,8.2-169.106,8.388-170l.81.166c-.183.892-18.207,90.01-8.377,169.73Z",
    transform: "translate(3.548 205.31)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g434",
    transform: "translate(628.355 329.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "M0-20.93s38.2-106.8,56.066-100.487S37.557-2.793,37.557-2.793Z",
    transform: "translate(0 121.686)",
    fill: "#00be7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g438",
    transform: "translate(577.632 330.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "M-2.712-25.238s-27.2-111.181-3.069-120.907S51.2-42.024,51.2-42.024Z",
    transform: "translate(15.766 146.734)",
    fill: "#00be7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g442",
    transform: "translate(592.45 343.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path444",
    d: "M-7.953-23.654c-19.8-37.108-32.68-75.379-38.288-113.752l.82-.121c5.594,38.279,18.447,76.46,38.2,113.482Z",
    transform: "translate(46.241 137.528)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g446",
    transform: "translate(640.907 356.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "M-.15-21l-.72-.41C17.773-54.25,29.9-88.122,35.186-122.082l.817.128C30.706-87.9,18.543-53.929-.15-21",
    transform: "translate(0.869 122.082)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g450",
    transform: "translate(636.228 407.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path452",
    d: "M0-.49l8.368,26.3h5.98L.937-2.851Z",
    transform: "translate(0 2.851)",
    fill: "#5ab289"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g454",
    transform: "translate(577.778 430.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path456",
    d: "M0,0H101.154L99.276,17.185H1.878Z",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g458",
    transform: "translate(585.302 447.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "M-4.112-11.143H42.772c5.777,0,10.7-3.787,11.6-8.926L62.2-64.785H-23.909L-16.138-20.4c.933,5.33,6.033,9.257,12.026,9.257",
    transform: "translate(23.909 64.785)",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M792.99-125.3H706.885v-.828H792.99Z",
    transform: "translate(-121.582 573.694)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g464",
    transform: "translate(667.505 49.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M-23.889-11.945a57.5,57.5,0,0,1-57.5,57.5,57.5,57.5,0,0,1-57.5-57.5,57.5,57.5,0,0,1,57.5-57.5,57.5,57.5,0,0,1,57.5,57.5",
    transform: "translate(138.893 69.446)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g468",
    transform: "translate(677.452 59.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M-19.757-9.879A47.556,47.556,0,0,1-67.313,37.677,47.555,47.555,0,0,1-114.868-9.879,47.555,47.555,0,0,1-67.313-57.435,47.556,47.556,0,0,1-19.757-9.879",
    transform: "translate(114.868 57.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    d: "M879.28-536.971H844.886v-2.208H879.28Z",
    transform: "translate(-145.318 644.738)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M876.484-535.4h-2.208v-39.721h2.208Z",
    transform: "translate(-150.373 650.92)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g476",
    transform: "translate(719.58 101.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M-2.255-1.127A5.427,5.427,0,0,1-7.682,4.3a5.427,5.427,0,0,1-5.427-5.427A5.427,5.427,0,0,1-7.682-6.555,5.427,5.427,0,0,1-2.255-1.127",
    transform: "translate(13.109 6.555)",
    fill: "#e96c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g480",
    transform: "translate(723.379 62.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M-.338-1.127h0A1.634,1.634,0,0,1-1.967-2.756v-2.17A1.634,1.634,0,0,1-.338-6.555,1.633,1.633,0,0,1,1.29-4.926v2.17A1.633,1.633,0,0,1-.338-1.127",
    transform: "translate(1.967 6.555)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g484",
    transform: "translate(723.379 145.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M-.338-1.127h0A1.634,1.634,0,0,1-1.967-2.756v-2.17A1.634,1.634,0,0,1-.338-6.555,1.633,1.633,0,0,1,1.29-4.926v2.17A1.633,1.633,0,0,1-.338-1.127",
    transform: "translate(1.967 6.555)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g488",
    transform: "translate(764.134 105.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M0-.338H0A1.632,1.632,0,0,1,1.628-1.967H3.8A1.633,1.633,0,0,1,5.427-.338,1.634,1.634,0,0,1,3.8,1.29H1.628A1.633,1.633,0,0,1,0-.338",
    transform: "translate(0 1.967)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g492",
    transform: "translate(680.454 105.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path494",
    d: "M0-.338H0A1.632,1.632,0,0,1,1.628-1.967H3.8A1.633,1.633,0,0,1,5.427-.338,1.634,1.634,0,0,1,3.8,1.29H1.628A1.633,1.633,0,0,1,0-.338",
    transform: "translate(0 1.967)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g496",
    transform: "translate(744.002 68.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path498",
    d: "M-.167-1.019h0a1.633,1.633,0,0,1-.58-2.229l1.1-1.871A1.632,1.632,0,0,1,2.579-5.7a1.632,1.632,0,0,1,.582,2.228L2.062-1.6a1.634,1.634,0,0,1-2.229.581",
    transform: "translate(0.97 5.922)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g500",
    transform: "translate(701.661 140.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M-.167-1.019h0a1.634,1.634,0,0,1-.58-2.229L.352-5.12A1.631,1.631,0,0,1,2.579-5.7a1.632,1.632,0,0,1,.582,2.228L2.062-1.6a1.635,1.635,0,0,1-2.229.581",
    transform: "translate(0.969 5.923)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g504",
    transform: "translate(758.533 125.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M-.046-.167h0A1.634,1.634,0,0,1,2.183-.748L4.055.351A1.628,1.628,0,0,1,2.407,3.16L.535,2.062A1.634,1.634,0,0,1-.046-.167",
    transform: "translate(0.269 0.97)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g508",
    transform: "translate(686.355 83.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M-.046-.167h0A1.633,1.633,0,0,1,2.183-.748L4.055.351A1.628,1.628,0,0,1,2.408,3.159L.535,2.061A1.632,1.632,0,0,1-.046-.167",
    transform: "translate(0.269 0.97)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g512",
    transform: "translate(701.558 68.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path514",
    d: "M-.739-1.018h0a1.634,1.634,0,0,0,.575-2.23l-1.1-1.869A1.633,1.633,0,0,0-3.5-5.691a1.634,1.634,0,0,0-.575,2.23l1.1,1.869a1.632,1.632,0,0,0,2.23.574",
    transform: "translate(4.298 5.916)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g516",
    transform: "translate(744.099 140.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M-.739-1.018h0a1.633,1.633,0,0,0,.574-2.23l-1.1-1.869A1.632,1.632,0,0,0-3.5-5.691a1.632,1.632,0,0,0-.575,2.229l1.1,1.869a1.633,1.633,0,0,0,2.23.575",
    transform: "translate(4.298 5.916)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g520",
    transform: "translate(686.415 125.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M-1.018-.166h0A1.633,1.633,0,0,0-3.248-.74L-5.117.363a1.634,1.634,0,0,0-.574,2.231,1.633,1.633,0,0,0,2.229.574l1.869-1.1a1.632,1.632,0,0,0,.575-2.23",
    transform: "translate(5.916 0.965)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g524",
    transform: "translate(758.476 83.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M-1.018-.166h0a1.633,1.633,0,0,0-2.23-.575L-5.117.363a1.633,1.633,0,0,0-.574,2.23,1.633,1.633,0,0,0,2.23.574l1.868-1.1a1.633,1.633,0,0,0,.575-2.23",
    transform: "translate(5.916 0.966)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g528",
    transform: "translate(705.965 119.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M0-3.255c0-5.924,8.189-6.8,8.189-10.715a2.777,2.777,0,0,0-3.021-2.761,4.09,4.09,0,0,0-3.375,2.124L.071-15.764a5.977,5.977,0,0,1,5.287-3.163c3.044,0,5.24,1.912,5.24,4.791,0,5.475-7.953,6.325-8.048,10.124h8.308v2.03H.117A8.408,8.408,0,0,1,0-3.255",
    transform: "translate(0 18.927)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g532",
    transform: "translate(718.662 119.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M-1.677-2.128v-6.09c0-.778.094-1.676.094-1.676h-.046A9.225,9.225,0,0,1-2.456-8.5l-4.72,6.325v.047Zm-8.072.495,7.718-10.738H.612V-2.128H2.878V-.169H.612v4.46H-1.677V-.169H-9.749Z",
    transform: "translate(9.749 12.371)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g536",
    transform: "translate(733.649 119.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M0,0H2.289V6.185a5.086,5.086,0,0,1-.094.99h.046A5.061,5.061,0,0,1,6.727,4.437c2.809,0,4.083,1.535,4.083,4.578v7.647H8.52V9.535c0-1.676-.33-3-2.241-3-2.314,0-3.99,1.888-3.99,4.46v5.665H0Z",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g540",
    transform: "translate(718.248 274.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M-1.821,0H-3.729a6.867,6.867,0,0,0-6.86,6.861v1.8a6.868,6.868,0,0,0,6.86,6.861h1.908a6.868,6.868,0,0,0,6.86-6.861v-1.8A6.867,6.867,0,0,0-1.821,0",
    transform: "translate(10.589)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g544",
    transform: "translate(708.549 208.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M-3.968,0a31.764,31.764,0,0,0-15.7,4.248,6.823,6.823,0,0,0-3.277,4.617A6.868,6.868,0,0,0-21.61,14.4l.512.657a6.8,6.8,0,0,0,8.672,1.716,16.192,16.192,0,0,1,7.716-2.1c5.545,0,9.568,3.356,9.568,7.98,0,4.863-3.236,7.774-7.332,11.461-4.96,4.462-10.582,9.521-10.582,19.173v.635a6.869,6.869,0,0,0,6.86,6.861h1.273a6.869,6.869,0,0,0,6.861-6.861c0-4.787,3.287-7.708,7.45-11.408C14.428,38.038,20.7,32.464,20.7,21.912,20.7,9.42,10.095,0-3.968,0",
    transform: "translate(23.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g548",
    transform: "translate(495.851 62.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M-24.661-5.42H-130.336a13.085,13.085,0,0,1-13.046-13.046,13.085,13.085,0,0,1,13.046-13.046H-24.661A13.085,13.085,0,0,1-11.615-18.466,13.085,13.085,0,0,1-24.661-5.42",
    transform: "translate(143.382 31.512)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g552",
    transform: "translate(505.636 66.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M-2-.188-.919,3.146a1.31,1.31,0,0,0,1.245.905H3.833A1.309,1.309,0,0,1,4.6,6.419L1.766,8.481A1.308,1.308,0,0,0,1.29,9.945L2.374,13.28A1.31,1.31,0,0,1,.358,14.744l-2.836-2.061a1.309,1.309,0,0,0-1.539,0l-2.837,2.061A1.309,1.309,0,0,1-8.869,13.28l1.084-3.335a1.311,1.311,0,0,0-.477-1.464L-11.1,6.419a1.309,1.309,0,0,1,.769-2.368h3.505a1.311,1.311,0,0,0,1.246-.905L-4.493-.188A1.309,1.309,0,0,1-2-.188",
    transform: "translate(11.639 1.093)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g556",
    transform: "translate(529.489 66.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M-2-.188-.919,3.146a1.31,1.31,0,0,0,1.245.905H3.833A1.309,1.309,0,0,1,4.6,6.419L1.766,8.481A1.308,1.308,0,0,0,1.29,9.945L2.374,13.28A1.31,1.31,0,0,1,.358,14.744l-2.836-2.061a1.309,1.309,0,0,0-1.539,0l-2.837,2.061A1.309,1.309,0,0,1-8.869,13.28l1.084-3.335a1.311,1.311,0,0,0-.477-1.464L-11.1,6.419a1.309,1.309,0,0,1,.769-2.368h3.506a1.311,1.311,0,0,0,1.246-.905L-4.494-.188A1.31,1.31,0,0,1-2-.188",
    transform: "translate(11.64 1.093)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g560",
    transform: "translate(553.342 66.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M-2-.188-.919,3.146a1.31,1.31,0,0,0,1.245.905H3.833A1.309,1.309,0,0,1,4.6,6.419L1.766,8.481A1.308,1.308,0,0,0,1.29,9.945L2.373,13.28A1.309,1.309,0,0,1,.358,14.744l-2.837-2.061a1.307,1.307,0,0,0-1.538,0l-2.837,2.061A1.309,1.309,0,0,1-8.869,13.28l1.083-3.335a1.308,1.308,0,0,0-.476-1.464L-11.1,6.419a1.309,1.309,0,0,1,.769-2.368h3.506a1.309,1.309,0,0,0,1.245-.905L-4.494-.188A1.31,1.31,0,0,1-2-.188",
    transform: "translate(11.64 1.093)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g564",
    transform: "translate(577.195 66.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M-2-.188-.919,3.146a1.31,1.31,0,0,0,1.245.905H3.833A1.309,1.309,0,0,1,4.6,6.419L1.766,8.481A1.308,1.308,0,0,0,1.29,9.945L2.373,13.28A1.309,1.309,0,0,1,.358,14.744l-2.837-2.061a1.309,1.309,0,0,0-1.539,0l-2.836,2.061A1.31,1.31,0,0,1-8.87,13.28l1.084-3.335a1.308,1.308,0,0,0-.476-1.464L-11.1,6.419a1.309,1.309,0,0,1,.769-2.368h3.506a1.309,1.309,0,0,0,1.245-.905L-4.494-.188A1.31,1.31,0,0,1-2-.188",
    transform: "translate(11.64 1.093)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g568",
    transform: "translate(601.048 66.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M-2-.188-.92,3.146a1.312,1.312,0,0,0,1.246.905H3.831A1.309,1.309,0,0,1,4.6,6.419L1.766,8.481a1.311,1.311,0,0,0-.477,1.464L2.373,13.28A1.309,1.309,0,0,1,.358,14.744l-2.837-2.061a1.309,1.309,0,0,0-1.539,0l-2.836,2.061A1.31,1.31,0,0,1-8.87,13.28l1.084-3.335a1.308,1.308,0,0,0-.476-1.464L-11.1,6.419a1.309,1.309,0,0,1,.769-2.368h3.506a1.309,1.309,0,0,0,1.245-.905L-4.494-.188A1.31,1.31,0,0,1-2-.188",
    transform: "translate(11.641 1.093)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g572",
    transform: "translate(636.638 489.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M-26.379-2.452H-149.113a4.27,4.27,0,0,1-4.257-4.258V-10a4.269,4.269,0,0,1,4.257-4.257H-26.379A4.269,4.269,0,0,1-22.122-10v3.291a4.27,4.27,0,0,1-4.257,4.258",
    transform: "translate(153.37 14.259)",
    fill: "#fabe7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g576",
    transform: "translate(731.027 493.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M-.369-.172a.95.95,0,0,0-.948.948.95.95,0,0,0,.948.949H24.248a.949.949,0,0,0,0-1.9ZM24.248,2.554H-.369A1.778,1.778,0,0,1-2.145.776,1.778,1.778,0,0,1-.369-1H24.248a1.777,1.777,0,0,1,0,3.554",
    transform: "translate(2.145 1)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    d: "M900.218-66.893h-.828v-2.726h.828Z",
    transform: "translate(-154.693 563.975)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    d: "M896.759-74.773H774.025V-75.6H896.759Z",
    transform: "translate(-133.13 565.004)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    d: "M803.064-60.515H38.013v-.828h765.05Z",
    transform: "translate(-6.538 562.551)",
    fill: "#512944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g586",
    transform: "translate(731.44 384.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path588",
    d: "M-12.976-4.1A32.542,32.542,0,0,1-30.091,38.62,32.541,32.541,0,0,1-72.812,21.505,32.542,32.542,0,0,1-55.7-21.216,32.542,32.542,0,0,1-12.976-4.1",
    transform: "translate(75.445 23.849)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g590",
    transform: "translate(741.813 445.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path592",
    d: "M-1.537,0l-7.4,39.549,17.484-37Z",
    transform: "translate(8.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g594",
    transform: "translate(741.412 394.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path596",
    d: "M-8.007-1.374a22.58,22.58,0,0,1,0,31.932,22.579,22.579,0,0,1-31.933,0,22.58,22.58,0,0,1,0-31.932,22.581,22.581,0,0,1,31.933,0",
    transform: "translate(46.554 7.987)",
    fill: "#80c7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g598",
    transform: "translate(751.081 404.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path600",
    d: "M-5.667-1.126a8.928,8.928,0,0,0-.448-1.963A3.555,3.555,0,0,0-7.154-4.569,7.547,7.547,0,0,0-12.8-6.529,25.161,25.161,0,0,0-32.712,12.429a7.806,7.806,0,0,0,.785,5.777,8.562,8.562,0,0,0,.765,1.1,2.463,2.463,0,0,0,1.687,1.052l1.652.328a1.343,1.343,0,0,0,1.379-.538,37.235,37.235,0,0,0,3.189-5.511,1.043,1.043,0,0,0-.231-1.2l-3.1-2.913A18.235,18.235,0,0,1-16.039-.066L-12.974,3a1.131,1.131,0,0,0,1.283.224A28.271,28.271,0,0,0-6.029-.223a1,1,0,0,0,.362-.9",
    transform: "translate(32.946 6.548)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g602",
    transform: "translate(741.008 394.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path604",
    d: "M-4.774-9.551a22.927,22.927,0,0,1-16.26-6.723,23.023,23.023,0,0,1,0-32.519,22.849,22.849,0,0,1,16.26-6.734v.828a22.016,22.016,0,0,0-15.672,6.492,22.193,22.193,0,0,0,0,31.348,22.188,22.188,0,0,0,31.346,0A22.129,22.129,0,0,0,16.94-37l.81-.167a22.961,22.961,0,0,1-6.264,20.893A22.928,22.928,0,0,1-4.774-9.551",
    transform: "translate(27.757 55.528)",
    fill: "#512944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g606",
    transform: "translate(40.804 305.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path608",
    d: "M-1.479-12.542a6.592,6.592,0,0,0,6.564-6.476L5.731-66.26a6.516,6.516,0,0,0-1.891-4.7A6.514,6.514,0,0,0-.834-72.917h-1.2A6.52,6.52,0,0,0-6.7-70.966a6.522,6.522,0,0,0-1.9,4.693l.553,47.242a6.592,6.592,0,0,0,6.567,6.489",
    transform: "translate(8.599 72.917)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g610",
    transform: "translate(40.746 373.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "M-1.639,0H-2.963A6.574,6.574,0,0,0-9.529,6.567V7.78a6.573,6.573,0,0,0,6.567,6.565h1.324A6.573,6.573,0,0,0,4.926,7.78V6.567A6.573,6.573,0,0,0-1.639,0",
    transform: "translate(9.529)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.cd6304c80924caa6264878f80f0dd588.svg";
export { ForwardRef as ReactComponent };